export const translations = {
  uk: {
    // Auth Screens
    login: "Увійти",
    register: "Реєстрація",
    forgotPassword: "Забули пароль?",
    forgotPasswordDesc:
      "Введіть вашу електронну пошту, і ми надішлемо вам посилання для скидання паролю",
    backToLogin: "Повернутися назад",
    sending: "Надсилання...",
    email: "Електронна пошта",
    password: "Пароль",
    confirmPassword: "Підтвердити пароль",
    name: "Ім'я",
    createAccount: "Створити акаунт",
    alreadyHaveAccount: "Вже маєте акаунт?",
    dontHaveAccount: "Немає акаунта?",
    loginFailed: "Помилка входу",
    registrationFailed: "Помилка реєстрації",
    fillAllFields: "Заповніть всі поля",
    passwordsDontMatch: "Паролі не співпадають",
    acceptTerms: "Я приймаю",
    termsLink: "Політика конфіденційності",
    termsError: "Необхідно прийняти умови використання",
    nameRequired: "Введіть ім'я",
    nameMinLength: "Ім'я повинно містити мінімум 2 символи",
    emailRequired: "Введіть email",
    emailInvalid: "Некорректний email",
    passwordRequired: "Введіть пароль",
    passwordMinLength: "Пароль повинен бути не менше 8 символів та містити літеру і цифру",
    confirmPasswordRequired: "Підтвердіть пароль",
    markdownSupport: "Підтримка Markdown",
    markdownSupportDesc: "Використовуйте Markdown для форматування повідомлень",
    typingAnimation: "Плавна анімація друку",
    typingAnimationDesc: "Повідомлення з'являються посимвольно",
    passwordTooShort: "Пароль повинен містити мінімум 8 символів",
    currentPasswordIncorrect: "Поточний пароль невірний",
    passwordChangedSuccessfully: "Пароль успішно змінено",
    alreadyExist: "Акаунт з такою поштою вже існує",
    badGateway: "Щось пішло не так. Спробуйте пізніше",
    invalidLoginData: "Неправильно введено пошту або пароль",
    emailNotVerified: "Email не підтверджено. Будь ласка, підтвердіть ваш email.",
    accountDeleted: "Цей акаунт було видалено. Вхід більше неможливий.",
    continueWithGoogle: "Увійти через Google",
    sessionExpired: "Сесія завершена",
    sessionExpiredDesc: "Будь ласка, увійдіть знову",
    
    // Email Verification
    emailVerification: "Підтвердження Email",
    verificationEmailSent: "Ми відправили код підтвердження на",
    verificationCode: "Код підтвердження",
    verificationCodeRequired: "Код підтвердження обов'язковий",
    verificationCodeLength: "Код повинен містити 6 цифр",
    verifyEmail: "Підтвердити Email",
    verificationFailed: "Помилка підтвердження коду",
    emailVerifiedSuccess: "Email успішно підтверджено. Тепер ви можете увійти в систему.",
    resendCode: "Відправити код повторно",
    resendCodeIn: "Повторно відправити через",
    codeResent: "Код повторно відправлено на вашу пошту",
    resendFailed: "Помилка відправки коду",
    backToRegister: "Повернутися до реєстрації",
    
    // Forgot Password
    sendResetCode: "Відправити код",
    resetPassword: "Скинути пароль",
    resetPasswordDesc: "Введіть код з пошти та новий пароль для",
    newPassword: "Новий пароль",
    forgotPasswordFailed: "Помилка відправки коду",
    endpointNotFound: "Endpoint не знайдено. Перевірте, чи запущений backend сервер.",
    resetPasswordFailed: "Помилка скидання пароля",
    passwordResetSuccess: "Пароль успішно скинуто",
    backToForgotPassword: "Повернутися до забутого пароля",

    // Navigation & Layout
    chat: "Чат",
    profile: "Профіль",
    settings: "Налаштування",
    blog: "Блог",
    newChat: "Новий чат",
    sharedChat: "Спільний чат",
    logout: "Вийти",
    welcome: "Ласкаво просимо",
    loading: "Завантаження...",
    opening_chat: "Відкриття чату...",

    // Chat Screen
    typeMessage: "Введіть повідомлення...",
    send: "Надіслати",
    chatHistory: "Історія чату",
    hello: "Привіт! Як справи?",
    howCanIHelp: "Чим можу допомогти?",
    howCanIHelpSubtitle: "Ваш AI асистент для розмов про фізичний стан організму, правильне харчування, здоровий спосіб життя",
    writeMessage: "Напишіть повідомлення...",
    editTitle: "Редагувати назву",
    deleteChat: "Видалити чат",
    deleteAll: "Видалити",
    confirmDeleteChat: "Ви дійсно хочете видалити чат?",
    medicalDisclaimer:
      "Відповідь в цьому чаті не є медичною консультацією лікаря. За потреби професійної медичної допомоги зверніться, будь-ласка, до кваліфікованого медичного фахівця.",
    confirmArchiveChatTitle: "Архівувати чат?",
    confirmArchiveChatDesc:
      "Після архівації чат зникне зі списку активних чатів, але залишиться в архіві.",
    archiveReadOnlyNotice:
      "Цей чат архівований і доступний лише для перегляду.",
    unarchiveChat: "Розархівувати чат",
    unarchiveConfirmation: "Розархівувати цей чат?",
    unarchiveConfirmationDesc:
      "Після розархівування чат знову з'явиться в списку активних чатів.",
    archivedChats: "Архівовані чати",
    showArchivedChats: "Показати архівовані чати",
    hideArchivedChats: "Приховати архівовані чати",
    moreActions: "Більше дій",
    rateUp: "Оцінити позитивно",
    rateDown: "Оцінити негативно",
    rateThankYouPositive: "Дякуємо за позитивну оцінку!",
    rateThankYouNegative: "Дякуємо за ваш фідбек!",

    // Profile Screen
    statistics: "Статистика",
    userId: "ID користувача",
    accountStatus: "Статус акаунту",
    active: "Активний",
    editProfile: "Редагування профілю",
    editProfileButton: "Редагувати профіль",
    changePassword: "Зміна паролю",
    changePasswordButton: "Змінити пароль",
    resetPassword: "Скидання паролю",
    resetPasswordButton: "Скинути пароль",
    sendResetEmail: "Надіслати лист",
    resetPasswordEmailSent:
      "Лист для скидання паролю надіслано на вашу електронну пошту",
    enterEmail: "Введіть електронну пошту",
    phone: "Телефон",
    currentPassword: "Поточний пароль",
    newPassword: "Новий пароль",
    confirmNewPassword: "Підтвердження паролю",
    save: "Зберегти",
    cancel: "Скасувати",
    deleteAccount: "Видалити акаунт",
    joinedOn: "Приєднався",
    logoutConfirmation: "Підтвердження виходу",
    logoutConfirmationDesc: "Ви впевнені, що хочете вийти з акаунту?",
    deleteAccountConfirmation: "Підтвердження видалення",
    deleteAccountConfirmationDesc:
      "Ви впевнені, що хочете видалити свій акаунт? Ця дія є незворотною.",
    enterCurrentPassword: "Введіть поточний пароль",
    delete: "Видалити",

    // Subscription
    subscription: "Підписка",
    subscriptionStatus: "Статус",
    subscriptionEnds: "Дата закінчення",
    requestsLeft: "Залишилось запитів",
    needSubscription: "Потрібна підписка",
    buySubscription: "Купити підписку",
    inactive: "Неактивна",
    subUnlimitedTitle: "Доступні тарифи",
    subNeedSubscriptionInfo: "Щоб продовжити користуватись ботом, потрібна підписка.",
    subBuyFor: "Оформити за {{amount}}",
    subThenPrice: "Потім {{amount}}/міс",
    subChooseOne: "Оберіть один з варіантів підписки",
    cancelSubscription: "Скасувати підписку",
    cancelSubscriptionTitle: "Скасувати підписку",
    cancelSubscriptionDesc: "Будь ласка, вкажіть причину скасування підписки:",
    loadingCancelOptions: "Завантаження опцій...",
    cancelOptionsUnavailable: "Опції скасування недоступні",
    selectAtLeastOneReason: "Будь ласка, оберіть хоча б одну причину",
    enterOtherReason: "Будь ласка, вкажіть причину в полі 'Інше'",
    subscriptionCancelledSuccess: "Підписку успішно скасовано",
    cancelSubscriptionError: "Помилка при скасуванні підписки",
    failedToLoadCancelOptions: "Не вдалося завантажити опції скасування",
    errorLoadingOptions: "Помилка при завантаженні опцій",
    other: "Інше",
    specifyReason: "Вкажіть причину",
    subscriptionCancellationInfoTitle: "Підписку скасовано",
    subscriptionCancellationInfoMessage:
      "Якщо у вас залишились доступні запити або термін підписки ще не завершився, ви можете користуватися сервісом до завершення оплаченого періоду.",
    gotIt: "Зрозуміло",

    // Modals (welcome / paywall / payment)
    welcomeTitle: "Привіт!",
    welcomeSubtitleText:
      "Мене звати АІ Начмед - я бот, який полегшить та спростить вашу роботу з відомою базою медичних даних PubMed.",
    welcomeParagraphText:
      "Мої послуги є платними, але перші 3 питання ви можете задати безкоштовно!",
    welcomePaymentParagraphText:
      "Після використання безкоштовних питань, щоб використовувати бота надалі, вам протрібно оформити підписку. Ви можете оплатити підписку за допомогою банківської картки.",
    subscriptionNeededTitle: "Потрібна підписка!",
    subscriptionNeededText:
      "Ви вичерпали ліміт безкоштовних запитань. Щоб продовжити, оформіть місячну підписку вартістю 10$.",
    paymentConfirmTitle: "Підтвердження оплати",
    paymentConfirmText:
      "Ви оформлюєте щомісячну підписку вартістю 10$. Оплата через WayForPay. Ви можете скасувати у будь-який момент.",
    pay: "Оплатити",
    subscriptionLimitText:
      "Нажаль, ви вичерпали свій ліміт запитань. Для того, щоб продовжувати отримувати відповіді від нашого бота, потрібно оформити платну підписку",
    subscriptionExpiredTitle: "Підписка завершилась",
    subscriptionExpiredText:
      "Термін дії вашої підписки закінчився. Щоб продовжити користування послугами, будь ласка, поновіть підписку.",
    paymentRequired: "Потрібна оплата",
    paymentRequiredText:
      "Для створення нового чату потрібна підписка. Будь ласка, придбайте підписку для продовження.",

    // Settings Screen
    basicSettings: "Основні налаштування",
    chatSettings: "Налаштування чату",
    backup: "Резервне копіювання",
    dangerZone: "Небезпечна зона",
    darkTheme: "Темна тема",
    darkThemeDesc: "Переключити між світлою та темною темою",
    language: "Мова",
    languageDesc: "Оберіть мову для інтерфейсу",
    animations: "Анімації",
    animationsDesc: "Увімкнути анімації інтерфейсу",
    showTimestamps: "Показувати час повідомлень",
    showTimestampsDesc: "Відображати час відправки кожного повідомлення",
    compactMode: "Компактний режим",
    compactModeDesc: "Зменшити відступи між повідомленнями",
    autoSave: "Автозбереження",
    autoSaveDesc: "Автоматично зберігати чати",
    exportData: "Експорт даних",
    exportDataDesc: "Завантажити всі дані у форматі JSON",
    importData: "Імпорт даних",
    importDataDesc: "Відновити дані з резервної копії",
    deleteAllData: "Видалити всі дані",
    deleteAllDataDesc: "Назавжди видалити всі чати та налаштування",
    export: "Експорт",
    import: "Імпорт",
    download: "Завантажити",
    exportDataModalDesc:
      "Буде створено файл з усіма вашими чатами, налаштуваннями та даними профілю.",
    importDataModalDesc: "Вставте вміст JSON файлу резервної копії:",
    pasteJsonData: "Вставте JSON дані сюди...",
    deleteConfirmation: "Підтвердження видалення",
    deleteConfirmationDesc:
      "Ви впевнені, що хочете видалити всі дані? Цю дію неможливо скасувати!",
    exportError: "Помилка експорту даних",
    importSuccess:
      "Дані успішно імпортовано! Перезавантажте сторінку для застосування змін.",
    importError: "Помилка імпорту даних. Перевірте формат файлу.",
    dataDeleted: "Всі дані видалено. Сторінка буде перезавантажена.",

    // Search Component
    searchChats: "Пошук чатів...",
    clearSearch: "Очистити пошук",
    searchResults: "Результати пошуку",
    noSearchResults: "Нічого не знайдено",
    tryDifferentKeywords: "Спробуйте інші ключові слова",
    match: "збіг",
    matches: "збігів",
    moreMatches: "ще збігів",
    you: "Ви",
    searchingFor: "Пошук за запитом",
    foundInMessages: "Знайдено в повідомленнях",
    foundInTitle: "Знайдено в назві",
    searchTip: "Пошук у назвах чатів та повідомленнях",
    searchEmptyState: "Почніть вводити для пошуку по чатам",
    totalResults: "Знайдено {{count}} результат",
    totalResults_plural: "Знайдено {{count}} результатів",
    recentChats: "Останні чати",
    navigate: "Навігація",
    select: "Вибрати",
    close: "Закрити",
    justNow: "Щойно",
    hoursAgo: "{{hours}} годин тому",
    yesterday: "Вчора",

    // Info Blocks Component
    information: "Інформація",
    askQuestion: "Нове питання",
    advantages: "Переваги",
    advantage1: "Швидкі та точні відповіді",
    advantage2: "Підтримка української мови",
    advantage3: "Перші 3 питання безкоштовно",
    advantage4: "Доступно 24/7",
    privacy: "Конфіденційність",
    privacy1: "Ваші дані захищені",
    privacy2: "Не передаємо інформацію третім особам",
    privacy3: "Можете видалити історію в будь-який час",
    privacy4: "Дотримуємось GDPR",

    // FAQ Screen
    faq: "FAQ",
    faqScreen: "FAQ",
    faqSubtitle: "Знайдіть відповіді на найпоширеніші питання про наш сервіс",
    faqSearchPlaceholder: "Пошук у питаннях...",
    faqCategory: "Категорія",
    faqAllCategories: "Всі категорії",
    faqGeneral: "Загальні питання",
    faqTechnical: "Технічні питання",
    faqPrivacy: "Конфіденційність",
    faqUsage: "Використання",
    faqStillHaveQuestions: "Залишились питання?",
    faqContactUs: "Зв'яжіться з нами",
    faqBackToTop: "Нагору",
    faq1: "Чи безпечно використовувати AI?",
    faq2: "Скільки це коштує?",
    faq3: "Чи зберігаються мої дані?",
    faq4: "Як покращити якість відповідей?",
    faq1Answer:
      "Так, наш AI безпечний у використанні. Ми використовуємо найсучасніші методи захисту даних та дотримуємось всіх стандартів безпеки. Ваші дані захищені та не передаються третім особам.",
    faq2Answer:
      "Мої послуги є платними, але перші 3 питання ви можете задати безкоштовно! Після використання безкоштовних питань, щоб користуватися ботом надалі, вам потрібно оформити підписку. Оплатити підписку можна банківською карткою.",
    faq3Answer:
      "Так, ми зберігаємо історію ваших чатів для покращення якості відповідей. Ви можете видалити свої дані в будь-який час через налаштування профілю.",
    faq4Answer:
      "Для отримання найкращих результатів, намагайтесь формулювати питання чітко та конкретно. Використовуйте детальні описи та вказуйте контекст, коли це необхідно.",

    // Chat Suggestions
    helpWithCode: "Допомога з кодом",
    helpWithCodeDesc: "Напишіть код, який потрібно виправити або покращити",
    translateText: "Переклад тексту",
    translateTextDesc: "Перекладіть текст на іншу мову",
    createPlan: "Створити план",
    createPlanDesc: "Розробіть план дій для вашого проекту",
    explainConcept: "Пояснити концепцію",
    explainConceptDesc: "Отримайте детальне пояснення складного поняття",
    copy: "Скопіювати",
    copied: "Скопійовано!",

    // Chat Menu Actions
    share: "Поширити",
    rename: "Перейменувати",
    archiveAction: "Архівувати",
    chatLink: "Посилання на чат",
    links: "Посилання:",
    allDetails: "Всі деталі",
    stanceYes: "Так",
    stanceLikely: "Ймовірно",
    stanceInconclusive: "Неоднозначно",
    stanceNo: "Ні",

    // Medical Suggestions
    suggestionHealthAnswers: "Наукові відповіді про здоровʼя",
    suggestionHealthAnswersDesc: "Шукаю наукове обґрунтуванння на ваші питання стосовно здоровʼя та правильного способу життя",

    // Hint Templates
    hintQuestion1: "Проаналізуй діючу речовину...",
    hintQuestion2: "Методи лікування...",
    hintQuestion3: "Дієта при...",
    hintQuestion4: "Дієвість косметологічної процедури...",
    hintQuestion5: "Що приймати при...",
    hintQuestion6: "Користь продуктів...",
    hintQuestion7: "Вітаміни для...",
    hintQuestion8: "Як прийом... впливає на покращення здоровʼя",

    archive: "Архів",
    noArchivedChats: "Архівованих чатів немає.",
    chooseChatToSeeMessages: "Оберіть чат, щоб переглянути повідомлення",
    archivedChatNotice: "Цей чат було архівовано",

    // Shared Chat Screen
    sharedNotFound: "Чат не знайдено",
    sharedNotFoundDesc: "Це посилання могло застаріти або бути видалено.",
    serverError: "Помилка сервера",
    serverErrorDesc: "Щось пішло не так. Спробуйте пізніше.",
    networkError: "Помилка з'єднання",
    networkErrorDesc: "Перевірте інтернет-з'єднання та спробуйте знову.",
    goToHome: "На головну",
    tryNachMed: "Спробувати NachMed AI",
    wantMoreAnswers: "Хочете більше медичних порад?",
    signUpForFree: "Зареєструйтесь безкоштовно та отримуйте персональні відповіді про здоров'я",
    createFreeAccount: "Створити безкоштовний акаунт",
    orDownloadApp: "або завантажте додаток",
    downloadAppDescription: "Завантажте мобільний додаток, реєструйтесь і отримуйте персональні відповіді про здоров'я",
  },
  ru: {
    // Auth Screens
    login: "Войти",
    register: "Регистрация",
    forgotPassword: "Забыли пароль?",
    forgotPasswordDesc:
      "Введите вашу электронную почту, и мы отправим вам ссылку для сброса пароля",
    backToLogin: "Вернуться назад",
    sending: "Отправка...",
    email: "Электронная почта",
    password: "Пароль",
    confirmPassword: "Подтвердить пароль",
    name: "Имя",
    createAccount: "Создать аккаунт",
    alreadyHaveAccount: "Уже есть аккаунт?",
    dontHaveAccount: "Нет аккаунта?",
    loginFailed: "Ошибка входа",
    registrationFailed: "Ошибка регистрации",
    fillAllFields: "Заполните все поля",
    passwordsDontMatch: "Пароли не совпадают",
    acceptTerms: "Я принимаю",
    termsLink: "Условия Использования",
    termsError: "Необходимо принять условия использования",
    nameRequired: "Введите имя",
    nameMinLength: "Имя должно содержать минимум 2 символа",
    emailRequired: "Введите email",
    emailInvalid: "Некорректный email",
    passwordRequired: "Введите пароль",
    passwordMinLength: "Пароль должен быть не менее 8 символов и содержать букву и цифру",
    confirmPasswordRequired: "Подтвердите пароль",
    markdownSupport: "Поддержка Markdown",
    markdownSupportDesc: "Используйте Markdown для форматирования сообщений",
    typingAnimation: "Плавная анимация печати",
    typingAnimationDesc: "Сообщения появляются посимвольно",
    passwordTooShort: "Пароль должен содержать минимум 8 символов",
    currentPasswordIncorrect: "Текущий пароль неверный",
    passwordChangedSuccessfully: "Пароль успешно изменён",
    alreadyExist: "Аккаунт с такой почтой уже существует",
    badGateway: "Что-то пошло не так. Попробуйте позже",
    invalidLoginData: "Неправильно введены почта или пароль",
    emailNotVerified: "Email не подтвержден. Пожалуйста, подтвердите ваш email.",
    accountDeleted: "Этот аккаунт был удалён. Вход больше невозможен.",
    continueWithGoogle: "Войти через Google",
    sessionExpired: "Сессия завершена",
    sessionExpiredDesc: "Пожалуйста, войдите снова",
    
    // Email Verification
    emailVerification: "Подтверждение Email",
    verificationEmailSent: "Мы отправили код подтверждения на",
    verificationCode: "Код подтверждения",
    verificationCodeRequired: "Код подтверждения обязателен",
    verificationCodeLength: "Код должен содержать 6 цифр",
    verifyEmail: "Подтвердить Email",
    verificationFailed: "Ошибка подтверждения кода",
    resendCode: "Отправить код повторно",
    resendCodeIn: "Повторно отправить через",
    codeResent: "Код повторно отправлен на вашу почту",
    resendFailed: "Ошибка отправки кода",
    backToRegister: "Вернуться к регистрации",
    
    // Forgot Password
    sendResetCode: "Отправить код",
    resetPassword: "Сбросить пароль",
    resetPasswordDesc: "Введите код с почты и новый пароль для",
    newPassword: "Новый пароль",
    forgotPasswordFailed: "Ошибка отправки кода",
    resetPasswordFailed: "Ошибка сброса пароля",
    passwordResetSuccess: "Пароль успешно сброшен",
    backToForgotPassword: "Вернуться к забытому паролю",

    // Navigation & Layout
    chat: "Чат",
    profile: "Профиль",
    settings: "Настройки",
    blog: "Блог",
    newChat: "Новый чат",
    sharedChat: "Общий чат",
    logout: "Выйти",
    welcome: "Добро пожаловать",
    loading: "Загрузка...",
    opening_chat: "Открытие чата...",

    // Chat Screen
    typeMessage: "Введите сообщение...",
    send: "Отправить",
    chatHistory: "История чата",
    hello: "Привет! Как дела?",
    howCanIHelp: "Чем могу помочь?",
    howCanIHelpSubtitle: "Ваш AI ассистент для разговоров о физическом состоянии организма, правильном питании, здоровом образе жизни",
    writeMessage: "Напишите сообщение...",
    editTitle: "Редактировать название",
    deleteChat: "Удалить чат",
    deleteAll: "Удалить",
    confirmDeleteChat: "Вы действительно хотите удалить чат?",
    medicalDisclaimer:
      "Ответ в этом чате не является медицинской консультацией врача. При необходимости профессиональной медицинской помощи обратитесь, пожалуйста, к квалифицированному медицинскому специалисту.",
    confirmArchiveChatTitle: "Архивировать чат?",
    confirmArchiveChatDesc:
      "После архивирования чат исчезнет из списка активных чатов, но останется в архиве.",
    archiveReadOnlyNotice:
      "Этот чат архивирован и доступен только для просмотра.",
    unarchiveChat: "Разархивировать чат",
    unarchiveConfirmation: "Разархивировать этот чат?",
    unarchiveConfirmationDesc:
      "После разархивирования чат снова появится в списке активных чатов.",
    archivedChats: "Архивированные чаты",
    showArchivedChats: "Показать архивированные чаты",
    hideArchivedChats: "Скрыть архивированные чаты",
    moreActions: "Больше действий",
    rateUp: "Оценить положительно",
    rateDown: "Оценить отрицательно",
    rateThankYouPositive: "Спасибо за положительную оценку!",
    rateThankYouNegative: "Спасибо за ваш отзыв!",

    // Profile Screen
    statistics: "Статистика",
    userId: "ID пользователя",
    accountStatus: "Статус аккаунта",
    active: "Активный",
    editProfile: "Редактирование профиля",
    editProfileButton: "Редактировать профиль",
    changePassword: "Изменить пароль",
    changePasswordButton: "Изменить пароль",
    resetPassword: "Сбросить пароль",
    resetPasswordButton: "Сбросить пароль",
    sendResetEmail: "Отправить письмо",
    resetPasswordEmailSent:
      "Письмо для сброса пароля отправлено на вашу электронную почту",
    enterEmail: "Введите электронную почту",
    phone: "Телефон",
    currentPassword: "Текущий пароль",
    newPassword: "Новый пароль",
    confirmNewPassword: "Подтверждение пароля",
    save: "Сохранить",
    cancel: "Отменить",
    deleteAccount: "Удалить аккаунт",
    joinedOn: "Присоединился",
    logoutConfirmation: "Подтверждение выхода",
    logoutConfirmationDesc: "Вы уверены, что хотите выйти из аккаунта?",
    deleteAccountConfirmation: "Подтверждение удаления аккаунта",
    deleteAccountConfirmationDesc:
      "Вы уверены, что хотите удалить свой аккаунт? Это действие необратимо.",
    enterCurrentPassword: "Введите текущий пароль",
    delete: "Удалить",

    // Subscription
    subscription: "Подписка",
    subscriptionStatus: "Статус",
    subscriptionEnds: "Дата окончания",
    requestsLeft: "Осталось запросов",
    needSubscription: "Нужна подписка",
    buySubscription: "Купить подписку",
    inactive: "Неактивна",
    subUnlimitedTitle: "Доступные тарифы",
    subNeedSubscriptionInfo: "Чтобы продолжить пользоваться ботом, нужна подписка.",
    subBuyFor: "Оформить за {{amount}}",
    subThenPrice: "Затем {{amount}}/мес",
    subChooseOne: "Выберите один из вариантов подписки",
    cancelSubscription: "Отменить подписку",
    cancelSubscriptionTitle: "Отменить подписку",
    cancelSubscriptionDesc: "Пожалуйста, укажите причину отмены подписки:",
    loadingCancelOptions: "Загрузка опций...",
    cancelOptionsUnavailable: "Опции отмены недоступны",
    selectAtLeastOneReason: "Пожалуйста, выберите хотя бы одну причину",
    enterOtherReason: "Пожалуйста, укажите причину в поле 'Другое'",
    subscriptionCancelledSuccess: "Подписка успешно отменена",
    cancelSubscriptionError: "Ошибка при отмене подписки",
    failedToLoadCancelOptions: "Не удалось загрузить опции отмены",
    errorLoadingOptions: "Ошибка при загрузке опций",
    other: "Другое",
    specifyReason: "Укажите причину",
    subscriptionCancellationInfoTitle: "Подписка отменена",
    subscriptionCancellationInfoMessage:
      "Если у вас остались доступные запросы или срок подписки ещё действителен, вы можете пользоваться сервисом до конца оплаченного периода.",
    gotIt: "Понятно",

    // Modals (welcome / paywall / payment)
    welcomeTitle: "Привет!",
    welcomeSubtitleText:
      "Меня зовут АИ Начмед - я бот, который облегчит и упростит вашу работу с известной базой медицинских данных PubMed.",
    welcomeParagraphText:
      "Мои услуги являются платными, но первые 3 вопроса вы можете задать бесплатно!",
    welcomePaymentParagraphText:
      "После использования бесплатных вопросов, чтобы продолжить пользоваться ботом, вам необходимо оформить подписку. Вы можете оплатить подписку банковской картой.",
    subscriptionNeededTitle: "Нужна подписка!",
    subscriptionNeededText:
      "Вы исчерпали лимит бесплатных вопросов. Чтобы продолжить, оформите месячную подписку стоимостью 10$.",
    paymentConfirmTitle: "Подтверждение оплаты",
    paymentConfirmText:
      "Вы оформляете ежемесячную подписку стоимостью 10$. Оплата через WayForPay. Вы можете отменить в любой момент.",
    pay: "Оплатить",
    subscriptionLimitText:
      "К сожалению, вы исчерпали лимит вопросов. Чтобы продолжать получать ответы от нашего бота, необходимо оформить платную ежемесячную подписку стоимостью 10$",
    subscriptionExpiredTitle: "Подписка завершилась",
    subscriptionExpiredText:
      "Срок действия вашей подписки истек. Чтобы продолжить пользование услугами, пожалуйста, обновите подписку.",
    paymentRequired: "Требуется оплата",
    paymentRequiredText:
      "Для создания нового чата требуется подписка. Пожалуйста, приобретите подписку для продолжения.",

    // Settings Screen
    basicSettings: "Основные настройки",
    chatSettings: "Настройки чата",
    backup: "Резервное копирование",
    dangerZone: "Опасная зона",
    darkTheme: "Темная тема",
    darkThemeDesc: "Переключить между светлой и темной темой",
    language: "Язык",
    languageDesc: "Выберите язык интерфейса",
    animations: "Анимации",
    animationsDesc: "Включить анимации интерфейса",
    showTimestamps: "Показывать время сообщений",
    showTimestampsDesc: "Отображать время отправки каждого сообщения",
    compactMode: "Компактный режим",
    compactModeDesc: "Уменьшить отступы между сообщениями",
    autoSave: "Автосохранение",
    autoSaveDesc: "Автоматически сохранять чаты",
    exportData: "Экспорт данных",
    exportDataDesc: "Скачать все данные в формате JSON",
    importData: "Импорт данных",
    importDataDesc: "Восстановить данные из резервної копії",
    deleteAllData: "Удалить все данные",
    deleteAllDataDesc: "Навсегда удалить все чаты и настройки",
    export: "Экспорт",
    import: "Импорт",
    download: "Скачать",
    exportDataModalDesc:
      "Будет создан файл со всеми вашими чатами, настройками и данными профиля.",
    importDataModalDesc: "Вставьте содержимое JSON файла резервної копії:",
    pasteJsonData: "Вставьте JSON данные сюда...",
    deleteConfirmation: "Подтверждение удаления",
    deleteConfirmationDesc:
      "Вы уверены, что хотите удалить все данные? Это действие нельзя отменить!",
    exportError: "Ошибка экспорта данных",
    importSuccess:
      "Данные успешно импортированы! Перезагрузите страницу для применения изменений.",
    importError: "Ошибка импорта данных. Проверьте формат файла.",
    dataDeleted: "Все данные удалены. Страница будет перезагружена.",

    // Search Component
    searchChats: "Поиск чатов...",
    clearSearch: "Очистить поиск",
    searchResults: "Результаты поиска",
    noSearchResults: "Ничего не найдено",
    tryDifferentKeywords: "Попробуйте другие ключевые слова",
    match: "совпадение",
    matches: "совпадений",
    moreMatches: "еще совпадений",
    you: "Вы",
    searchingFor: "Поиск по запросу",
    foundInMessages: "Найдено в сообщениях",
    foundInTitle: "Найдено в названии",
    searchTip: "Поиск в названиях чатов и сообщениях",
    searchEmptyState: "Начните вводить для поиска по чатам",
    totalResults: "Найден {{count}} результат",
    totalResults_plural: "Найдено {{count}} результатов",
    recentChats: "Недавние чаты",
    navigate: "Навигация",
    select: "Выбрать",
    close: "Закрыть",
    justNow: "Только что",
    hoursAgo: "{{hours}} часов назад",
    yesterday: "Вчера",

    // Info Blocks Component
    information: "Информация",
    askQuestion: "Новый вопрос",
    advantages: "Преимущества",
    advantage1: "Быстрые и точные ответы",
    advantage2: "Поддержка русского языка",
    advantage3: "Первые 3 вопроса бесплатно",
    advantage4: "Доступно 24/7",
    privacy: "Конфиденциальность",
    privacy1: "Ваши данные защищены",
    privacy2: "Не передаем информацию третьим лицам",
    privacy3: "Можете удалить историю в любое время",
    privacy4: "Соблюдаем GDPR",

    // FAQ Screen
    faq: "FAQ",
    faqScreen: "FAQ",
    faqSubtitle:
      "Найдите ответы на самые распространенные вопросы о нашем сервисе",
    faqSearchPlaceholder: "Поиск по вопросам...",
    faqCategory: "Категория",
    faqAllCategories: "Все категории",
    faqGeneral: "Общие вопросы",
    faqTechnical: "Технические вопросы",
    faqPrivacy: "Конфиденциальность",
    faqUsage: "Использование",
    faqStillHaveQuestions: "Остались вопросы?",
    faqContactUs: "Свяжитесь с нами",
    faqBackToTop: "Наверх",
    faq1: "Безопасно ли использовать AI?",
    faq2: "Сколько это стоит?",
    faq3: "Сохраняются ли мои данные?",
    faq4: "Как улучшить качество ответов?",
    faq1Answer:
      "Да, наш AI безопасен в использовании. Мы применяем современные методы защиты данных и соблюдаем все стандарты безопасности. Ваши данные защищены и не передаются третьим лицам.",
    faq2Answer:
      "Мои услуги являются платными, но вы можете задать первые 3 вопроса бесплатно! После использования бесплатных вопросов, чтобы продолжать пользоваться ботом, вам необходимо оформить подписку. Оплатить подписку можно банковской картой.",
    faq3Answer:
      "Да, мы сохраняем историю ваших чатов для улучшения качества ответов. Вы можете удалить свои данные в любое время через настройки профиля.",
    faq4Answer:
      "Для лучших результатов старайтесь формулировать вопросы чётко и конкретно. Добавляйте детальные описания и указывайте контекст, когда это необходимо.",

    // Chat Suggestions
    helpWithCode: "Помощь с кодом",
    helpWithCodeDesc: "Write code that needs to be fixed or improved",
    translateText: "Перевод текста",
    translateTextDesc: "Переведите текст на другой язык",
    createPlan: "Создать план",
    createPlanDesc: "Разработайте план действий для вашего проекта",
    explainConcept: "Объяснить концепцию",
    explainConceptDesc: "Получите подробное объяснение сложного понятия",
    copy: "Скопировать",
    copied: "Скопировано!",

    // Chat Menu Actions
    share: "Поделиться",
    rename: "Переименовать",
    archiveAction: "Архивировать",
    chatLink: "Ссылка на чат",
    links: "Ссылки:",
    allDetails: "Все детали",
    stanceYes: "Да",
    stanceLikely: "Вероятно",
    stanceInconclusive: "Неоднозначно",
    stanceNo: "Нет",

    // Medical Suggestions
    suggestionHealthAnswers: "Научные ответы о здоровье",
    suggestionHealthAnswersDesc: "Ищу научное обоснование ваших вопросов относительно здоровья и правильного образа жизни",

    // Hint Templates
    hintQuestion1: "Проанализируй действующее вещество...",
    hintQuestion2: "Методы лечения...",
    hintQuestion3: "Диета при...",
    hintQuestion4: "Эффективность косметологической процедуры...",
    hintQuestion5: "Что принимать при...",
    hintQuestion6: "Польза продуктов...",
    hintQuestion7: "Витамины для...",
    hintQuestion8: "Как приём... влияет на улучшение здоровья",

    archive: "Архив",
    noArchivedChats: "Архивированных чатов нет.",
    chooseChatToSeeMessages: "Выберите чат, чтобы просмотреть сообщения",
    archivedChatNotice: "Этот чат был архивирован",

    // Shared Chat Screen
    sharedNotFound: "Чат не найден",
    sharedNotFoundDesc: "Эта ссылка могла устареть или быть удалена.",
    serverError: "Ошибка сервера",
    serverErrorDesc: "Что-то пошло не так. Попробуйте позже.",
    networkError: "Ошибка соединения",
    networkErrorDesc: "Проверьте интернет-соединение и попробуйте снова.",
    goToHome: "На главную",
    tryNachMed: "Попробовать NachMed AI",
    wantMoreAnswers: "Хотите больше медицинских советов?",
    signUpForFree: "Зарегистрируйтесь бесплатно и получайте персональные ответы о здоровье",
    createFreeAccount: "Создать бесплатный аккаунт",
    orDownloadApp: "или скачайте приложение",
    downloadAppDescription: "Скачайте мобильное приложение, регистрируйтесь и получайте персональные ответы о здоровье",
  },
  en: {
    // Auth Screens
    login: "Login",
    register: "Register",
    forgotPassword: "Forgot Password?",
    forgotPasswordDesc:
      "Enter your email, and we will send you a link to reset your password",
    backToLogin: "Go Back",
    sending: "Sending...",
    email: "Email",
    password: "Password",
    confirmPassword: "Confirm Password",
    name: "Name",
    createAccount: "Create Account",
    alreadyHaveAccount: "Already have an account?",
    dontHaveAccount: "Don't have an account?",
    loginFailed: "Login failed",
    registrationFailed: "Registration failed",
    fillAllFields: "Please fill in all fields",
    passwordsDontMatch: "Passwords do not match",
    acceptTerms: "I accept the",
    termsLink: "Terms of Use",
    termsError: "You must accept the terms of use",
    nameRequired: "Please enter your name",
    nameMinLength: "Name must be at least 2 characters long",
    emailRequired: "Please enter your email",
    emailInvalid: "Invalid email address",
    passwordRequired: "Please enter your password",
    passwordMinLength: "Password must be at least 8 characters and contain a letter and a number",
    confirmPasswordRequired: "Please confirm your password",
    markdownSupport: "Markdown Support",
    markdownSupportDesc: "Use Markdown to format your messages",
    typingAnimation: "Smooth Typing Animation",
    typingAnimationDesc: "Messages appear character by character",
    passwordTooShort: "Password must be at least 8 characters long",
    currentPasswordIncorrect: "Current password is incorrect",
    passwordChangedSuccessfully: "Password changed successfully",
    alreadyExist: "An account with this email already exists",
    badGateway: "Something went wrong. Please try again later",
    invalidLoginData: "Incorrect email or password entered",
    emailNotVerified: "Email not verified. Please verify your email.",
    accountDeleted: "This account has been deleted. Login is no longer possible.",
    continueWithGoogle: "Continue with Google",
    sessionExpired: "Session ended",
    sessionExpiredDesc: "Please log in again",
    
    // Email Verification
    emailVerification: "Email Verification",
    verificationEmailSent: "We sent a verification code to",
    verificationCode: "Verification Code",
    verificationCodeRequired: "Verification code is required",
    verificationCodeLength: "Code must contain 6 digits",
    verifyEmail: "Verify Email",
    verificationFailed: "Verification code error",
    resendCode: "Resend Code",
    resendCodeIn: "Resend code in",
    codeResent: "Code resent to your email",
    resendFailed: "Failed to resend code",
    backToRegister: "Back to Registration",
    
    // Forgot Password
    sendResetCode: "Send Code",
    resetPassword: "Reset Password",
    resetPasswordDesc: "Enter code from email and new password for",
    newPassword: "New Password",
    forgotPasswordFailed: "Failed to send code",
    resetPasswordFailed: "Failed to reset password",
    passwordResetSuccess: "Password reset successfully",
    backToForgotPassword: "Back to Forgot Password",

    // Navigation & Layout
    chat: "Chat",
    profile: "Profile",
    settings: "Settings",
    blog: "Blog",
    newChat: "New chat",
    sharedChat: "Shared chat",
    logout: "Logout",
    welcome: "Welcome",
    loading: "Loading...",
    opening_chat: "Opening chat...",

    // Chat Screen
    typeMessage: "Type a message...",
    send: "Send",
    chatHistory: "Chat History",
    hello: "Hello! How are you?",
    howCanIHelp: "How can I help you?",
    howCanIHelpSubtitle: "Your AI assistant for conversations about physical health, proper nutrition, and healthy lifestyle",
    writeMessage: "Write your message...",
    editTitle: "Edit title",
    deleteChat: "Delete chat",
    deleteAll: "Delete",
    confirmDeleteChat: "Are you sure you want to delete the chat?",
    medicalDisclaimer:
      "The response in this chat is not a doctor's medical consultation. If you need professional medical help, please consult a qualified healthcare professional.",
    confirmArchiveChatTitle: "Archive chat?",
    confirmArchiveChatDesc:
      "After archiving, the chat will disappear from the active chats list but remain in the archive.",
    archiveReadOnlyNotice:
      "This chat is archived and available for viewing only.",
    unarchiveChat: "Unarchive chat",
    unarchiveConfirmation: "Unarchive this chat?",
    unarchiveConfirmationDesc:
      "After unarchiving, the chat will appear again in the active chats list.",
    archivedChats: "Archived chats",
    showArchivedChats: "Show archived chats",
    hideArchivedChats: "Hide archived chats",
    moreActions: "More actions",
    rateUp: "Rate up",
    rateDown: "Rate down",
    rateThankYouPositive: "Thank you for your positive feedback!",
    rateThankYouNegative: "Thank you for your feedback!",

    // Profile Screen
    statistics: "Statistics",
    userId: "User ID",
    accountStatus: "Account Status",
    active: "Active",
    editProfile: "Edit Profile",
    editProfileButton: "Edit Profile",
    changePassword: "Change Password",
    changePasswordButton: "Change Password",
    resetPassword: "Reset Password",
    resetPasswordButton: "Reset Password",
    sendResetEmail: "Send Email",
    resetPasswordEmailSent: "Password reset email sent to your email",
    enterEmail: "Enter your email",
    phone: "Phone",
    currentPassword: "Current Password",
    newPassword: "New Password",
    confirmNewPassword: "Confirm Password",
    save: "Save",
    cancel: "Cancel",
    deleteAccount: "Delete Account",
    joinedOn: "Joined",
    logoutConfirmation: "Logout Confirmation",
    logoutConfirmationDesc: "Are you sure you want to logout?",
    deleteAccountConfirmation: "Delete Account Confirmation",
    deleteAccountConfirmationDesc:
      "Are you sure you want to delete your account? This action is irreversible.",
    enterCurrentPassword: "Enter current password",
    delete: "Delete",

    // Subscription
    subscription: "Subscription",
    subscriptionStatus: "Status",
    subscriptionEnds: "End date",
    requestsLeft: "Requests left",
    needSubscription: "Subscription required",
    buySubscription: "Buy subscription",
    inactive: "Inactive",
    subUnlimitedTitle: "Available plans",
    subNeedSubscriptionInfo: "To continue using the bot, a subscription is required.",
    subBuyFor: "Buy for {{amount}}",
    subThenPrice: "Then {{amount}}/mo",
    subChooseOne: "Choose one of the subscription options",
    cancelSubscription: "Cancel Subscription",
    cancelSubscriptionTitle: "Cancel Subscription",
    cancelSubscriptionDesc: "Please specify the reason for canceling your subscription:",
    loadingCancelOptions: "Loading options...",
    cancelOptionsUnavailable: "Cancel options unavailable",
    selectAtLeastOneReason: "Please select at least one reason",
    enterOtherReason: "Please specify the reason in the 'Other' field",
    subscriptionCancelledSuccess: "Subscription successfully cancelled",
    cancelSubscriptionError: "Error canceling subscription",
    failedToLoadCancelOptions: "Failed to load cancel options",
    errorLoadingOptions: "Error loading options",
    other: "Other",
    specifyReason: "Specify reason",
    subscriptionCancellationInfoTitle: "Subscription cancelled",
    subscriptionCancellationInfoMessage:
      "If you still have available questions or your subscription period is still valid, you can continue using the service until the end of the paid term.",
    gotIt: "Got it",

    // Modals (welcome / paywall / payment)
    welcomeTitle: "Hello!",
    welcomeSubtitleText:
      "My name is AI Nachmed - I'm a bot that will facilitate and simplify your work with the well-known PubMed medical database.",
    welcomeParagraphText:
      "My services are paid, but you can ask the first 3 questions for free!",
    welcomePaymentParagraphText:
      "After using the free questions, to continue using the bot, you need to purchase a subscription. You can pay for the subscription with a bank card.",
    subscriptionNeededTitle: "Subscription required!",
    subscriptionNeededText:
      "You have used your free questions. To continue, please purchase a monthly subscription for $10.",
    paymentConfirmTitle: "Payment confirmation",
    paymentConfirmText:
      "You are about to purchase a $10 monthly subscription via WayForPay. You can cancel anytime.",
    pay: "Pay",
    subscriptionLimitText:
      "Unfortunately, you have exhausted your question limit. To continue receiving answers from our bot, you need to purchase a paid monthly subscription costing $10",
    subscriptionExpiredTitle: "Subscription expired",
    subscriptionExpiredText:
      "Your subscription has expired. To continue using our services, please renew your subscription.",
    paymentRequired: "Payment Required",
    paymentRequiredText:
      "A subscription is required to create a new chat. Please purchase a subscription to continue.",

    // Settings Screen
    basicSettings: "Basic Settings",
    chatSettings: "Chat Settings",
    backup: "Backup",
    dangerZone: "Danger Zone",
    darkTheme: "Dark Theme",
    darkThemeDesc: "Switch between light and dark theme",
    language: "Language",
    languageDesc: "Choose interface language",
    animations: "Animations",
    animationsDesc: "Enable interface animations",
    showTimestamps: "Show Message Timestamps",
    showTimestampsDesc: "Display time for each message",
    compactMode: "Compact Mode",
    compactModeDesc: "Reduce spacing between messages",
    autoSave: "Auto Save",
    autoSaveDesc: "Automatically save chats",
    exportData: "Export Data",
    exportDataDesc: "Download all data in JSON format",
    importData: "Import Data",
    importDataDesc: "Restore data from backup",
    deleteAllData: "Delete All Data",
    deleteAllDataDesc: "Permanently delete all chats and settings",
    export: "Export",
    import: "Import",
    download: "Download",
    exportDataModalDesc:
      "A file will be created with all your chats, settings, and profile data.",
    importDataModalDesc: "Paste the contents of your backup JSON file:",
    pasteJsonData: "Paste JSON data here...",
    deleteConfirmation: "Delete Confirmation",
    deleteConfirmationDesc:
      "Are you sure you want to delete all data? This action cannot be undone!",
    exportError: "Error exporting data",
    importSuccess:
      "Data successfully imported! Reload the page to apply changes.",
    importError: "Error importing data. Please check the file format.",
    dataDeleted: "All data has been deleted. The page will be reloaded.",

    // Search Component
    searchChats: "Search chats...",
    clearSearch: "Clear search",
    searchResults: "Search Results",
    noSearchResults: "No results found",
    tryDifferentKeywords: "Try different keywords",
    match: "match",
    matches: "matches",
    moreMatches: "more matches",
    you: "You",
    searchingFor: "Searching for",
    foundInMessages: "Found in messages",
    foundInTitle: "Found in title",
    searchTip: "Search in chat names and messages",
    searchEmptyState: "Start typing to search through your chats",
    totalResults: "{{count}} result found",
    totalResults_plural: "{{count}} results found",
    recentChats: "Recent Chats",
    navigate: "Navigate",
    select: "Select",
    close: "Close",
    justNow: "Just now",
    hoursAgo: "{{hours}} hours ago",
    yesterday: "Yesterday",

    // Info Blocks Component
    information: "Information",
    askQuestion: "New Question",
    advantages: "Advantages",
    advantage1: "Fast and accurate responses",
    advantage2: "Support for multiple languages",
    advantage3: "First 3 questions free",
    advantage4: "Available 24/7",
    privacy: "Privacy",
    privacy1: "Your data is protected",
    privacy2: "We don't share information with third parties",
    privacy3: "You can delete history at any time",
    privacy4: "We comply with GDPR",

    // FAQ Screen
    faq: "FAQ",
    faqScreen: "FAQ",
    faqSubtitle: "Find answers to the most common questions about our service",
    faqSearchPlaceholder: "Search questions...",
    faqCategory: "Category",
    faqAllCategories: "All Categories",
    faqGeneral: "General Questions",
    faqTechnical: "Technical Questions",
    faqPrivacy: "Privacy",
    faqUsage: "Usage",
    faqStillHaveQuestions: "Still have questions?",
    faqContactUs: "Contact Us",
    faqBackToTop: "Back to Top",
    faq1: "Is it safe to use AI?",
    faq2: "How much does it cost?",
    faq3: "Are my data stored?",
    faq4: "How to improve response quality?",
    faq1Answer:
      "Yes, our AI is safe to use. We use state-of-the-art data protection methods and comply with all security standards. Your data is protected and not shared with third parties.",
    faq2Answer:
      "My services are paid, but you can ask the first 3 questions for free! After using the free questions, to keep using the bot, you need to purchase a subscription. You can pay for the subscription with a bank card.",
    faq3Answer:
      "Yes, we store your chat history to improve response quality. You can delete your data at any time through your profile settings.",
    faq4Answer:
      "For the best results, try to formulate questions clearly and specifically. Use detailed descriptions and provide context when necessary.",

    // Chat Suggestions
    helpWithCode: "Help with code",
    helpWithCodeDesc: "Write code that needs to be fixed or improved",
    translateText: "Translate text",
    translateTextDesc: "Translate text to another language",
    createPlan: "Create a plan",
    createPlanDesc: "Develop an action plan for your project",
    explainConcept: "Explain a concept",
    explainConceptDesc: "Get a detailed explanation of a complex concept",
    copy: "Copy",
    copied: "Copied!",

    // Chat Menu Actions
    share: "Share",
    rename: "Rename",
    archiveAction: "Archive",
    chatLink: "Chat link",
    links: "Links:",
    allDetails: "All details",
    stanceYes: "Yes",
    stanceLikely: "Likely",
    stanceInconclusive: "Inconclusive",
    stanceNo: "No",

    // Medical Suggestions
    suggestionHealthAnswers: "Scientific answers about health",
    suggestionHealthAnswersDesc: "I'm looking for scientific justification for your questions regarding health and proper lifestyle",

    // Hint Templates
    hintQuestion1: "Analyze active ingredient...",
    hintQuestion2: "Treatment methods for...",
    hintQuestion3: "Diet for...",
    hintQuestion4: "Effectiveness of cosmetic procedure...",
    hintQuestion5: "What to take for...",
    hintQuestion6: "Benefits of products...",
    hintQuestion7: "Vitamins for...",
    hintQuestion8: "How taking... affects health improvement",

    archive: "Archive",
    noArchivedChats: "No archived chats.",
    chooseChatToSeeMessages: "Choose the chat to see messages",
    archivedChatNotice: "This chat was archived",

    // Shared Chat Screen
    sharedNotFound: "Chat not found",
    sharedNotFoundDesc: "This shared link may have expired or been removed.",
    serverError: "Server error",
    serverErrorDesc: "Something went wrong. Please try again later.",
    networkError: "Connection error",
    networkErrorDesc: "Please check your internet connection and try again.",
    goToHome: "Go to Home",
    tryNachMed: "Try NachMed AI",
    wantMoreAnswers: "Want more medical insights?",
    signUpForFree: "Sign up for free and get personalized health answers",
    createFreeAccount: "Create Free Account",
    orDownloadApp: "or download the app",
    downloadAppDescription: "Download the mobile app, sign up and get personalized health answers",
  },
  pl: {
    // Auth Screens
    login: "Zaloguj się",
    register: "Rejestracja",
    forgotPassword: "Zapomniałeś hasła?",
    forgotPasswordDesc:
      "Wpisz swój email, a my wyślemy ci link do resetowania hasła",
    backToLogin: "Powrót",
    sending: "Wysyłanie...",
    email: "Adres e-mail",
    password: "Hasło",
    confirmPassword: "Potwierdź hasło",
    name: "Imię",
    createAccount: "Utwórz konto",
    alreadyHaveAccount: "Masz już konto?",
    dontHaveAccount: "Nie masz konta?",
    loginFailed: "Logowanie nie powiodło się",
    registrationFailed: "Błąd rejestracji",
    fillAllFields: "Wypełnij wszystkie pola",
    passwordsDontMatch: "Hasła nie są zgodne",
    acceptTerms: "Akceptuję",
    termsLink: "Warunki Użytkowania",
    termsError: "Musisz zaakceptować warunki użytkowania",
    nameRequired: "Wprowadź swoje imię",
    nameMinLength: "Imię musi mieć co najmniej 2 znaki",
    emailRequired: "Wprowadź swój email",
    emailInvalid: "Nieprawidłowy adres email",
    passwordRequired: "Wprowadź swoje hasło",
    passwordMinLength: "Hasło musi mieć co najmniej 8 znaków i zawierać literę oraz cyfrę",
    confirmPasswordRequired: "Potwierdź swoje hasło",
    markdownSupport: "Wsparcie Markdown",
    markdownSupportDesc: "Używaj Markdown do formatowania wiadomości",
    typingAnimation: "Płynna animacja pisania",
    typingAnimationDesc: "Wiadomości pojawiają się znak po znaku",
    passwordTooShort: "Hasło musi mieć co najmniej 8 znaków",
    currentPasswordIncorrect: "Obecne hasło jest nieprawidłowe",
    passwordChangedSuccessfully: "Hasło zostało pomyślnie zmienione",
    alreadyExist: "Konto z tym adresem e-mail już istnieje",
    badGateway: "Coś poszło nie tak. Spróbuj ponownie później",
    invalidLoginData: "Nieprawidłowy e-mail lub hasło",
    emailNotVerified: "Email nie zweryfikowany. Proszę zweryfikować swój email.",
    accountDeleted: "To konto zostało usunięte. Logowanie nie jest już możliwe.",
    continueWithGoogle: "Zaloguj się przez Google",
    sessionExpired: "Sesja zakończona",
    sessionExpiredDesc: "Proszę zalogować się ponownie",
    
    // Email Verification
    emailVerification: "Weryfikacja Email",
    verificationEmailSent: "Wysłaliśmy kod weryfikacyjny na",
    verificationCode: "Kod Weryfikacyjny",
    verificationCodeRequired: "Kod weryfikacyjny jest wymagany",
    verificationCodeLength: "Kod musi zawierać 6 cyfr",
    verifyEmail: "Zweryfikuj Email",
    verificationFailed: "Błąd weryfikacji kodu",
    resendCode: "Wyślij kod ponownie",
    resendCodeIn: "Wyślij kod ponownie za",
    codeResent: "Kod został ponownie wysłany na Twój email",
    resendFailed: "Błąd wysyłania kodu",
    backToRegister: "Wróć do rejestracji",
    
    // Forgot Password
    sendResetCode: "Wyślij kod",
    resetPassword: "Resetuj hasło",
    resetPasswordDesc: "Wprowadź kod z e-maila i nowe hasło dla",
    newPassword: "Nowe hasło",
    forgotPasswordFailed: "Błąd wysyłania kodu",
    resetPasswordFailed: "Błąd resetowania hasła",
    passwordResetSuccess: "Hasło zostało pomyślnie zresetowane",
    backToForgotPassword: "Wróć do zapomnianego hasła",

    // Navigation & Layout
    chat: "Czat",
    profile: "Profil",
    settings: "Ustawienia",
    blog: "Blog",
    newChat: "Nowy czat",
    sharedChat: "Udostępniony czat",
    logout: "Wyloguj się",
    welcome: "Witaj",
    loading: "Ładowanie...",
    opening_chat: "Otwieranie czatu...",

    // Chat Screen
    typeMessage: "Wpisz wiadomość...",
    send: "Wyślij",
    chatHistory: "Historia czatu",
    hello: "Cześć! Jak się masz?",
    howCanIHelp: "W czym mogę pomóc?",
    howCanIHelpSubtitle: "Twój asystent AI do rozmów o fizycznym stanie organizmu, prawidłowym odżywianiu i zdrowym stylu życia",
    writeMessage: "Napisz wiadomość...",
    editTitle: "Edytuj tytuł",
    deleteChat: "Usuń czat",
    deleteAll: "Usuń",
    confirmDeleteChat: "Czy na pewno chcesz usunąć czat?",
    medicalDisclaimer:
      "Odpowiedź w tym czacie nie jest konsultacją lekarską. W razie potrzeby profesjonalnej pomocy medycznej skonsultuj się, proszę, z wykwalifikowanym pracownikiem służby zdrowia.",
    confirmArchiveChatTitle: "Zarchiwizować czat?",
    confirmArchiveChatDesc:
      "Po zarchiwizowaniu czat zniknie z listy aktywnych czatów, ale pozostanie w archiwum.",
    archiveReadOnlyNotice:
      "Ten czat został zarchiwizowany i jest dostępny tylko do podglądu.",
    unarchiveChat: "Przywróć czat",
    unarchiveConfirmation: "Przywrócić ten czat?",
    unarchiveConfirmationDesc:
      "Po przywróceniu czat ponownie pojawi się na liście aktywnych czatów.",
    archivedChats: "Zarchiwizowane czaty",
    showArchivedChats: "Pokaż zarchiwizowane czaty",
    hideArchivedChats: "Ukryj zarchiwizowane czaty",
    moreActions: "Więcej akcji",
    rateUp: "Oceń pozytywnie",
    rateDown: "Oceń negatywnie",
    rateThankYouPositive: "Dziękujemy za pozytywną ocenę!",
    rateThankYouNegative: "Dziękujemy za Twoją opinię!",

    // Profile Screen
    statistics: "Statystyki",
    userId: "ID użytkownika",
    accountStatus: "Status konta",
    active: "Aktywny",
    editProfile: "Edytuj profil",
    editProfileButton: "Edytuj profil",
    changePassword: "Zmiana hasła",
    changePasswordButton: "Zmień hasło",
    resetPassword: "Reset hasła",
    resetPasswordButton: "Resetuj hasło",
    sendResetEmail: "Wyślij email",
    resetPasswordEmailSent: "Email resetowania hasła wysłany na twoją pocztę",
    enterEmail: "Wprowadź email",
    phone: "Telefon",
    currentPassword: "Obecne hasło",
    newPassword: "Nowe hasło",
    confirmNewPassword: "Potwierdź hasło",
    save: "Zapisz",
    cancel: "Anuluj",
    deleteAccount: "Usuń konto",
    joinedOn: "Dołączył",
    logoutConfirmation: "Potwierdzenie wylogowania",
    logoutConfirmationDesc: "Czy na pewno chcesz się wylogować?",
    deleteAccountConfirmation: "Potwierdzenie usunięcia konta",
    deleteAccountConfirmationDesc:
      "Czy na pewno chcesz usunąć swoje konto? Ta akcja jest nieodwracalna.",
    enterCurrentPassword: "Wprowadź obecne hasło",
    delete: "Usuń",

    // Subscription
    subscription: "Subskrypcja",
    subscriptionStatus: "Status",
    subscriptionEnds: "Data zakończenia",
    requestsLeft: "Pozostało zapytań",
    needSubscription: "Wymagana subskrypcja",
    buySubscription: "Kup subskrypcję",
    inactive: "Nieaktywna",
    subUnlimitedTitle: "Dostępne plany",
    subNeedSubscriptionInfo: "Aby kontynuować korzystanie z bota, wymagana jest subskrypcja.",
    subBuyFor: "Kup za {{amount}}",
    subThenPrice: "Potem {{amount}}/mies",
    subChooseOne: "Wybierz jedną z opcji subskrypcji",
    cancelSubscription: "Anuluj subskrypcję",
    cancelSubscriptionTitle: "Anuluj subskrypcję",
    cancelSubscriptionDesc: "Proszę podać powód anulowania subskrypcji:",
    loadingCancelOptions: "Ładowanie opcji...",
    cancelOptionsUnavailable: "Opcje anulowania niedostępne",
    selectAtLeastOneReason: "Proszę wybrać co najmniej jeden powód",
    enterOtherReason: "Proszę podać powód w polu 'Inne'",
    subscriptionCancelledSuccess: "Subskrypcja została pomyślnie anulowana",
    cancelSubscriptionError: "Błąd podczas anulowania subskrypcji",
    failedToLoadCancelOptions: "Nie udało się załadować opcji anulowania",
    errorLoadingOptions: "Błąd podczas ładowania opcji",
    other: "Inne",
    specifyReason: "Podaj powód",
    subscriptionCancellationInfoTitle: "Subskrypcję anulowano",
    subscriptionCancellationInfoMessage:
      "Jeśli masz jeszcze dostępne pytania lub okres subskrypcji nadal trwa, możesz korzystać z usługi do końca opłaconego okresu.",
    gotIt: "Rozumiem",

    // Modals (welcome / paywall / payment)
    welcomeTitle: "Cześć!",
    welcomeSubtitleText:
      "Nazywam się AI Nachmed - jestem botem, który ułatwi i uprości Twoją pracę ze znaną bazą danych medycznych PubMed.",
    welcomeParagraphText:
      "Moje usługi są płatne, ale pierwsze 3 pytania możesz zadać za darmo!",
    welcomePaymentParagraphText:
      "Po wykorzystaniu darmowych pytań, aby dalej korzystać z bota, musisz wykupić subskrypcję. Za subskrypcję możesz zapłacić kartą bankową.",
    subscriptionNeededTitle: "Wymagana subskrypcja!",
    subscriptionNeededText:
      "Wykorzystałeś limit darmowych pytań. Aby kontynuować, wykup miesięczną subskrypcję za 10$.",
    paymentConfirmTitle: "Potwierdzenie płatności",
    paymentConfirmText:
      "Kupujesz miesięczną subskrypcję za 10$ poprzez WayForPay. Możesz anulować w każdej chwili.",
    pay: "Zapłać",
    subscriptionLimitText:
      "Niestety, wyczerpałeś swój limit pytań. Aby nadal otrzymywać odpowiedzi od naszego bota, musisz wykupić płatną miesięczną subskrypcję w cenie 10$",
    subscriptionExpiredTitle: "Subskrypcja wygasła",
    subscriptionExpiredText:
      "Twoja subskrypcja wygasła. Aby kontynuować korzystanie z naszych usług, odnów subskrypcję.",
    paymentRequired: "Wymagana płatność",
    paymentRequiredText:
      "Do utworzenia nowego czatu wymagana jest subskrypcja. Proszę zakupić subskrypcję, aby kontynuować.",

    // Settings Screen
    basicSettings: "Podstawowe ustawienia",
    chatSettings: "Ustawienia czatu",
    backup: "Kopia zapasowa",
    dangerZone: "Strefa niebezpieczna",
    darkTheme: "Ciemny motyw",
    darkThemeDesc: "Przełącz między jasnym i ciemnym motywem",
    language: "Język",
    languageDesc: "Wybierz język interfejsu",
    animations: "Animacje",
    animationsDesc: "Włącz animacje interfejsu",
    showTimestamps: "Pokaż znaczniki czasu",
    showTimestampsDesc: "Wyświetlaj czas wysłania każdej wiadomości",
    compactMode: "Tryb kompaktowy",
    compactModeDesc: "Zmniejsz odstępy między wiadomościami",
    autoSave: "Autozapisywanie",
    autoSaveDesc: "Automatycznie zapisuj czaty",
    exportData: "Eksportuj dane",
    exportDataDesc: "Pobierz wszystkie dane w formacie JSON",
    importData: "Importuj dane",
    importDataDesc: "Przywróć dane z kopii zapasowej",
    deleteAllData: "Usuń wszystkie dane",
    deleteAllDataDesc: "Trwale usuń wszystkie czaty i ustawienia",
    export: "Eksportuj",
    import: "Importuj",
    download: "Pobierz",
    exportDataModalDesc:
      "Zostanie utworzony plik ze wszystkimi Twoimi czatami, ustawieniami i danymi profilu.",
    importDataModalDesc: "Wklej zawartość pliku JSON kopii zapasowej:",
    pasteJsonData: "Wklej dane JSON tutaj...",
    deleteConfirmation: "Potwierdzenie usunięcia",
    deleteConfirmationDesc:
      "Czy na pewno chcesz usunąć wszystkie dane? Tej operacji nie można cofnąć!",
    exportError: "Błąd eksportu danych",
    importSuccess:
      "Dane zostały pomyślnie zaimportowane! Odśwież stronę, aby zastosować zmiany.",
    importError: "Błąd importowania danych. Sprawdź format pliku.",
    dataDeleted: "Wszystkie dane zostały usunięte. Strona zostanie odświeżona.",

    // Search Component
    searchChats: "Wyszukaj czaty...",
    clearSearch: "Wyczyść wyszukiwanie",
    searchResults: "Wyniki wyszukiwania",
    noSearchResults: "Brak wyników",
    tryDifferentKeywords: "Spróbuj innych słów kluczowych",
    match: "dopasowanie",
    matches: "dopasowań",
    moreMatches: "więcej dopasowań",
    you: "Ty",
    searchingFor: "Wyszukiwanie dla",
    foundInMessages: "Znaleziono w wiadomościach",
    foundInTitle: "Znaleziono w tytule",
    searchTip: "Wyszukuj w nazwach czatów i wiadomościach",
    searchEmptyState: "Zacznij pisać, aby przeszukać czaty",
    totalResults: "Znaleziono {{count}} wynik",
    totalResults_2: "Znaleziono {{count}} wyniki",
    totalResults_plural: "Znaleziono {{count}} wyników",
    recentChats: "Ostatnie czaty",
    navigate: "Nawiguj",
    select: "Wybierz",
    close: "Zamknij",
    justNow: "Teraz",
    hoursAgo: "{{hours}} godzin temu",
    yesterday: "Wczoraj",

    // Info Blocks Component
    information: "Informacja",
    askQuestion: "Nowe pytanie",
    advantages: "Zalety",
    advantage1: "Szybkie i dokładne odpowiedzi",
    advantage2: "Wsparcie dla języka polskiego",
    advantage3: "Pierwsze 3 pytania za darmo",
    advantage4: "Dostępne 24/7",
    privacy: "Prywatność",
    privacy1: "Twoje dane są chronione",
    privacy2: "Nie udostępniamy informacji osobom trzecim",
    privacy3: "Możesz usunąć historię w dowolnym momencie",
    privacy4: "Przestrzegamy GDPR",

    // FAQ Screen
    faq: "FAQ",
    faqScreen: "FAQ",
    faqSubtitle:
      "Znajdź odpowiedzi na najczęściej zadawane pytania o naszym serwisie",
    faqSearchPlaceholder: "Szukaj w pytaniach...",
    faqCategory: "Kategoria",
    faqAllCategories: "Wszystkie kategorie",
    faqGeneral: "Pytania ogólne",
    faqTechnical: "Pytania techniczne",
    faqPrivacy: "Prywatność",
    faqUsage: "Użytkowanie",
    faqStillHaveQuestions: "Masz jeszcze pytania?",
    faqContactUs: "Skontaktuj się z nami",
    faqBackToTop: "Powrót do góry",
    faq1: "Czy bezpiecznie jest używać AI?",
    faq2: "Ile to kosztuje?",
    faq3: "Czy moje dane są przechowywane?",
    faq4: "Jak poprawić jakość odpowiedzi?",
    faq1Answer:
      "Tak, nasz AI jest bezpieczny w użyciu. Wykorzystujemy najnowocześniejsze metody ochrony danych i przestrzegamy wszystkich standardów bezpieczeństwa. Twoje dane są chronione i nie są udostępniane osobom trzecim.",
    faq2Answer:
      "Moje usługi są płatne, ale możesz zadać pierwsze 3 pytania za darmо! Po wykorzystaniu darmowych pytań, aby dalej korzystać z bota, musisz wykupić subskrypcję. Za subskrypcję możesz zapłacić kartą płatniczą.",
    faq3Answer:
      "Tak, przechowujemy historię Twoich czatów, aby poprawić jakość odpowiedzi. Możesz usunąć swoje dane w dowolnym momencie przez ustawienia profilu.",
    faq4Answer:
      "Aby uzyskać najlepsze wyniki, staraj się formułować pytania jasno i konkretnie. Używaj szczegółowych opisów i podawaj kontekst, gdy jest to konieczne.",

    // Chat Suggestions
    helpWithCode: "Pomoc z kodem",
    helpWithCodeDesc: "Napisz kod, który wymaga naprawy lub ulepszenia",
    translateText: "Przetłumacz tekst",
    translateTextDesc: "Przetłumacz tekst na inny język",
    createPlan: "Utwórz plan",
    createPlanDesc: "Opracuj plan działania dla swojego projektu",
    explainConcept: "Wyjaśnij koncepcję",
    explainConceptDesc: "Uzyskaj szczegółowe wyjaśnienie złożonego pojęcia",
    copy: "Kopiuj",
    copied: "Skopiowano!",

    // Chat Menu Actions
    share: "Udostępnij",
    rename: "Zmień nazwę",
    archiveAction: "Archiwizuj",
    chatLink: "Link do czatu",
    links: "Linki:",
    allDetails: "Wszystkie szczegóły",
    stanceYes: "Tak",
    stanceLikely: "Prawdopodobnie",
    stanceInconclusive: "Niejednoznaczne",
    stanceNo: "Nie",

    // Medical Suggestions
    suggestionHealthAnswers: "Naukowe odpowiedzi o zdrowiu",
    suggestionHealthAnswersDesc: "Szukam naukowego uzasadnienia dla Twoich pytań dotyczących zdrowia i właściwego stylu życia",

    // Hint Templates
    hintQuestion1: "Przeanalizuj substancję czynną...",
    hintQuestion2: "Metody leczenia...",
    hintQuestion3: "Dieta przy...",
    hintQuestion4: "Skuteczność zabiegu kosmetycznego...",
    hintQuestion5: "Co brać przy...",
    hintQuestion6: "Korzyści z produktów...",
    hintQuestion7: "Witaminy na...",
    hintQuestion8: "Jak przyjmowanie... wpływa na poprawę zdrowia",

    archive: "Archiwum",
    noArchivedChats: "Brak zarchiwizowanych czatów.",
    chooseChatToSeeMessages: "Wybierz czat, aby zobaczyć wiadomości",
    archivedChatNotice: "Ten czat został zarchiwizowany",

    // Shared Chat Screen
    sharedNotFound: "Nie znaleziono czatu",
    sharedNotFoundDesc: "Ten link mógł wygasnąć lub zostać usunięty.",
    serverError: "Błąd serwera",
    serverErrorDesc: "Coś poszło nie tak. Spróbuj ponownie później.",
    networkError: "Błąd połączenia",
    networkErrorDesc: "Sprawdź połączenie internetowe i spróbuj ponownie.",
    goToHome: "Strona główna",
    tryNachMed: "Wypróbuj NachMed AI",
    wantMoreAnswers: "Chcesz więcej porad medycznych?",
    signUpForFree: "Zarejestruj się za darmo i otrzymuj spersonalizowane odpowiedzi dotyczące zdrowia",
    createFreeAccount: "Utwórz bezpłatne konto",
    orDownloadApp: "lub pobierz aplikację",
    downloadAppDescription: "Pobierz aplikację mobilną, zarejestruj się i otrzymuj spersonalizowane odpowiedzi dotyczące zdrowia",
  },
  es: {
    // Auth Screens
    login: "Iniciar sesión",
    register: "Registrarse",
    forgotPassword: "¿Olvidaste tu contraseña?",
    forgotPasswordDesc:
      "Ingresa tu correo electrónico y te enviaremos un enlace para restablecer tu contraseña",
    backToLogin: "Volver",
    sending: "Enviando...",
    email: "Correo electrónico",
    password: "Contraseña",
    confirmPassword: "Confirmar contraseña",
    name: "Nombre",
    createAccount: "Crear cuenta",
    alreadyHaveAccount: "¿Ya tienes una cuenta?",
    dontHaveAccount: "¿No tienes cuenta?",
    loginFailed: "Error al iniciar sesión",
    registrationFailed: "Error de registro",
    fillAllFields: "Por favor, completa todos los campos",
    passwordsDontMatch: "Las contraseñas no coinciden",
    acceptTerms: "Acepto los",
    termsLink: "Términos de uso",
    termsError: "Debes aceptar los términos de uso",
    nameRequired: "Por favor, ingresa tu nombre",
    nameMinLength: "El nombre debe tener al menos 2 caracteres",
    emailRequired: "Por favor, ingresa tu correo electrónico",
    emailInvalid: "Correo electrónico inválido",
    passwordRequired: "Por favor, ingresa tu contraseña",
    passwordMinLength: "La contraseña debe tener al menos 8 caracteres y contener una letra y un número",
    confirmPasswordRequired: "Por favor, confirma tu contraseña",
    markdownSupport: "Soporte de Markdown",
    markdownSupportDesc: "Usa Markdown para formatear tus mensajes",
    typingAnimation: "Animación de escritura suave",
    typingAnimationDesc: "Los mensajes aparecen carácter por carácter",
    passwordTooShort: "La contraseña debe tener al menos 8 caracteres",
    currentPasswordIncorrect: "La contraseña actual es incorrecta",
    passwordChangedSuccessfully: "Contraseña cambiada exitosamente",
    alreadyExist: "Ya existe una cuenta con este correo electrónico",
    badGateway: "Algo salió mal. Por favor, inténtalo más tarde",
    invalidLoginData: "Correo electrónico o contraseña incorrectos",
    emailNotVerified: "Correo no verificado. Por favor, verifica tu correo.",
    accountDeleted: "Esta cuenta ha sido eliminada. Ya no es posible iniciar sesión.",
    continueWithGoogle: "Continuar con Google",
    sessionExpired: "Sesión finalizada",
    sessionExpiredDesc: "Por favor, inicia sesión de nuevo",

    // Email Verification
    emailVerification: "Verificación de correo",
    verificationEmailSent: "Enviamos un código de verificación a",
    verificationCode: "Código de verificación",
    verificationCodeRequired: "El código de verificación es obligatorio",
    verificationCodeLength: "El código debe contener 6 dígitos",
    verifyEmail: "Verificar correo",
    verificationFailed: "Error en la verificación del código",
    resendCode: "Reenviar código",
    resendCodeIn: "Reenviar código en",
    codeResent: "Código reenviado a tu correo",
    resendFailed: "Error al reenviar el código",
    backToRegister: "Volver al registro",

    // Forgot Password
    sendResetCode: "Enviar código",
    resetPassword: "Restablecer contraseña",
    resetPasswordDesc: "Ingresa el código del correo y la nueva contraseña para",
    newPassword: "Nueva contraseña",
    forgotPasswordFailed: "Error al enviar el código",
    resetPasswordFailed: "Error al restablecer la contraseña",
    passwordResetSuccess: "Contraseña restablecida exitosamente",
    backToForgotPassword: "Volver a contraseña olvidada",

    // Navigation & Layout
    chat: "Chat",
    profile: "Perfil",
    settings: "Configuración",
    blog: "Blog",
    newChat: "Nuevo chat",
    sharedChat: "Chat compartido",
    logout: "Cerrar sesión",
    welcome: "Bienvenido",
    loading: "Cargando...",
    opening_chat: "Abriendo chat...",

    // Chat Screen
    typeMessage: "Escribe un mensaje...",
    send: "Enviar",
    chatHistory: "Historial de chat",
    hello: "¡Hola! ¿Cómo estás?",
    howCanIHelp: "¿En qué puedo ayudarte?",
    howCanIHelpSubtitle: "Tu asistente de IA para conversaciones sobre salud física, nutrición adecuada y estilo de vida saludable",
    writeMessage: "Escribe tu mensaje...",
    editTitle: "Editar título",
    deleteChat: "Eliminar chat",
    deleteAll: "Eliminar",
    confirmDeleteChat: "¿Estás seguro de que deseas eliminar el chat?",
    medicalDisclaimer:
      "La respuesta en este chat no es una consulta médica profesional. Si necesitas ayuda médica profesional, consulta a un profesional de la salud calificado.",
    confirmArchiveChatTitle: "¿Archivar chat?",
    confirmArchiveChatDesc:
      "Después de archivar, el chat desaparecerá de la lista de chats activos pero permanecerá en el archivo.",
    archiveReadOnlyNotice:
      "Este chat está archivado y solo está disponible para lectura.",
    unarchiveChat: "Desarchivar chat",
    unarchiveConfirmation: "¿Desarchivar este chat?",
    unarchiveConfirmationDesc:
      "Después de desarchivar, el chat aparecerá nuevamente en la lista de chats activos.",
    archivedChats: "Chats archivados",
    showArchivedChats: "Mostrar chats archivados",
    hideArchivedChats: "Ocultar chats archivados",
    moreActions: "Más acciones",
    rateUp: "Calificar positivamente",
    rateDown: "Calificar negativamente",
    rateThankYouPositive: "¡Gracias por tu calificación positiva!",
    rateThankYouNegative: "¡Gracias por tu comentario!",

    // Profile Screen
    statistics: "Estadísticas",
    userId: "ID de usuario",
    accountStatus: "Estado de la cuenta",
    active: "Activo",
    editProfile: "Editar perfil",
    editProfileButton: "Editar perfil",
    changePassword: "Cambiar contraseña",
    changePasswordButton: "Cambiar contraseña",
    resetPasswordButton: "Restablecer contraseña",
    sendResetEmail: "Enviar correo",
    resetPasswordEmailSent: "Correo de restablecimiento enviado a tu correo electrónico",
    enterEmail: "Ingresa tu correo electrónico",
    phone: "Teléfono",
    currentPassword: "Contraseña actual",
    confirmNewPassword: "Confirmar contraseña",
    save: "Guardar",
    cancel: "Cancelar",
    deleteAccount: "Eliminar cuenta",
    joinedOn: "Se unió el",
    logoutConfirmation: "Confirmación de cierre de sesión",
    logoutConfirmationDesc: "¿Estás seguro de que deseas cerrar sesión?",
    deleteAccountConfirmation: "Confirmación de eliminación de cuenta",
    deleteAccountConfirmationDesc:
      "¿Estás seguro de que deseas eliminar tu cuenta? Esta acción es irreversible.",
    enterCurrentPassword: "Ingresa la contraseña actual",
    delete: "Eliminar",

    // Subscription
    subscription: "Suscripción",
    subscriptionStatus: "Estado",
    subscriptionEnds: "Fecha de finalización",
    requestsLeft: "Solicitudes restantes",
    needSubscription: "Se requiere suscripción",
    buySubscription: "Comprar suscripción",
    inactive: "Inactiva",
    subUnlimitedTitle: "Planes disponibles",
    subNeedSubscriptionInfo: "Para continuar usando el bot, se requiere una suscripción.",
    subBuyFor: "Comprar por {{amount}}",
    subThenPrice: "Luego {{amount}}/mes",
    subChooseOne: "Elige una de las opciones de suscripción",
    cancelSubscription: "Cancelar suscripción",
    cancelSubscriptionTitle: "Cancelar suscripción",
    cancelSubscriptionDesc: "Por favor, especifica el motivo de la cancelación:",
    loadingCancelOptions: "Cargando opciones...",
    cancelOptionsUnavailable: "Opciones de cancelación no disponibles",
    selectAtLeastOneReason: "Por favor, selecciona al menos un motivo",
    enterOtherReason: "Por favor, especifica el motivo en el campo 'Otro'",
    subscriptionCancelledSuccess: "Suscripción cancelada exitosamente",
    cancelSubscriptionError: "Error al cancelar la suscripción",
    failedToLoadCancelOptions: "No se pudieron cargar las opciones de cancelación",
    errorLoadingOptions: "Error al cargar opciones",
    other: "Otro",
    specifyReason: "Especifica el motivo",
    subscriptionCancellationInfoTitle: "Suscripción cancelada",
    subscriptionCancellationInfoMessage:
      "Si aún tienes preguntas disponibles o tu período de suscripción sigue vigente, puedes continuar usando el servicio hasta el final del período pagado.",
    gotIt: "Entendido",

    // Modals (welcome / paywall / payment)
    welcomeTitle: "¡Hola!",
    welcomeSubtitleText:
      "Mi nombre es AI Nachmed - soy un bot que facilitará y simplificará tu trabajo con la conocida base de datos médicos PubMed.",
    welcomeParagraphText:
      "Mis servicios son de pago, ¡pero puedes hacer las primeras 3 preguntas gratis!",
    welcomePaymentParagraphText:
      "Después de usar las preguntas gratuitas, para continuar usando el bot, necesitas comprar una suscripción. Puedes pagar la suscripción con tarjeta bancaria.",
    subscriptionNeededTitle: "¡Se requiere suscripción!",
    subscriptionNeededText:
      "Has agotado tus preguntas gratuitas. Para continuar, compra una suscripción mensual por $10.",
    paymentConfirmTitle: "Confirmación de pago",
    paymentConfirmText:
      "Estás comprando una suscripción mensual de $10 a través de WayForPay. Puedes cancelar en cualquier momento.",
    pay: "Pagar",
    subscriptionLimitText:
      "Lamentablemente, has agotado tu límite de preguntas. Para seguir recibiendo respuestas de nuestro bot, necesitas comprar una suscripción mensual de pago de $10",
    subscriptionExpiredTitle: "Suscripción expirada",
    subscriptionExpiredText:
      "Tu suscripción ha expirado. Para continuar usando nuestros servicios, renueva tu suscripción.",
    paymentRequired: "Pago requerido",
    paymentRequiredText:
      "Se requiere una suscripción para crear un nuevo chat. Por favor, compra una suscripción para continuar.",

    // Settings Screen
    basicSettings: "Configuración básica",
    chatSettings: "Configuración del chat",
    backup: "Copia de seguridad",
    dangerZone: "Zona de peligro",
    darkTheme: "Tema oscuro",
    darkThemeDesc: "Cambiar entre tema claro y oscuro",
    language: "Idioma",
    languageDesc: "Elige el idioma de la interfaz",
    animations: "Animaciones",
    animationsDesc: "Activar animaciones de la interfaz",
    showTimestamps: "Mostrar marcas de tiempo",
    showTimestampsDesc: "Mostrar la hora de envío de cada mensaje",
    compactMode: "Modo compacto",
    compactModeDesc: "Reducir el espaciado entre mensajes",
    autoSave: "Guardado automático",
    autoSaveDesc: "Guardar chats automáticamente",
    exportData: "Exportar datos",
    exportDataDesc: "Descargar todos los datos en formato JSON",
    importData: "Importar datos",
    importDataDesc: "Restaurar datos desde copia de seguridad",
    deleteAllData: "Eliminar todos los datos",
    deleteAllDataDesc: "Eliminar permanentemente todos los chats y configuraciones",
    export: "Exportar",
    import: "Importar",
    download: "Descargar",
    exportDataModalDesc:
      "Se creará un archivo con todos tus chats, configuraciones y datos de perfil.",
    importDataModalDesc: "Pega el contenido del archivo JSON de respaldo:",
    pasteJsonData: "Pega los datos JSON aquí...",
    deleteConfirmation: "Confirmación de eliminación",
    deleteConfirmationDesc:
      "¿Estás seguro de que deseas eliminar todos los datos? ¡Esta acción no se puede deshacer!",
    exportError: "Error al exportar datos",
    importSuccess:
      "¡Datos importados exitosamente! Recarga la página para aplicar los cambios.",
    importError: "Error al importar datos. Por favor, verifica el formato del archivo.",
    dataDeleted: "Todos los datos han sido eliminados. La página se recargará.",

    // Search Component
    searchChats: "Buscar chats...",
    clearSearch: "Limpiar búsqueda",
    searchResults: "Resultados de búsqueda",
    noSearchResults: "No se encontraron resultados",
    tryDifferentKeywords: "Intenta con otras palabras clave",
    match: "coincidencia",
    matches: "coincidencias",
    moreMatches: "más coincidencias",
    you: "Tú",
    searchingFor: "Buscando",
    foundInMessages: "Encontrado en mensajes",
    foundInTitle: "Encontrado en el título",
    searchTip: "Buscar en nombres de chats y mensajes",
    searchEmptyState: "Comienza a escribir para buscar en tus chats",
    totalResults: "{{count}} resultado encontrado",
    totalResults_plural: "{{count}} resultados encontrados",
    recentChats: "Chats recientes",
    navigate: "Navegar",
    select: "Seleccionar",
    close: "Cerrar",
    justNow: "Ahora mismo",
    hoursAgo: "hace {{hours}} horas",
    yesterday: "Ayer",

    // Info Blocks Component
    information: "Información",
    askQuestion: "Nueva pregunta",
    advantages: "Ventajas",
    advantage1: "Respuestas rápidas y precisas",
    advantage2: "Soporte en español",
    advantage3: "Las primeras 3 preguntas son gratis",
    advantage4: "Disponible 24/7",
    privacy: "Privacidad",
    privacy1: "Tus datos están protegidos",
    privacy2: "No compartimos información con terceros",
    privacy3: "Puedes eliminar el historial en cualquier momento",
    privacy4: "Cumplimos con GDPR",

    // FAQ Screen
    faq: "FAQ",
    faqScreen: "FAQ",
    faqSubtitle: "Encuentra respuestas a las preguntas más frecuentes sobre nuestro servicio",
    faqSearchPlaceholder: "Buscar en preguntas...",
    faqCategory: "Categoría",
    faqAllCategories: "Todas las categorías",
    faqGeneral: "Preguntas generales",
    faqTechnical: "Preguntas técnicas",
    faqPrivacy: "Privacidad",
    faqUsage: "Uso",
    faqStillHaveQuestions: "¿Aún tienes preguntas?",
    faqContactUs: "Contáctanos",
    faqBackToTop: "Volver arriba",
    faq1: "¿Es seguro usar IA?",
    faq2: "¿Cuánto cuesta?",
    faq3: "¿Se almacenan mis datos?",
    faq4: "¿Cómo mejorar la calidad de las respuestas?",
    faq1Answer:
      "Sí, nuestra IA es segura de usar. Utilizamos métodos de protección de datos de última generación y cumplimos con todos los estándares de seguridad. Tus datos están protegidos y no se comparten con terceros.",
    faq2Answer:
      "Mis servicios son de pago, ¡pero puedes hacer las primeras 3 preguntas gratis! Después de usar las preguntas gratuitas, para seguir usando el bot, necesitas comprar una suscripción. Puedes pagar la suscripción con tarjeta bancaria.",
    faq3Answer:
      "Sí, almacenamos el historial de tus chats para mejorar la calidad de las respuestas. Puedes eliminar tus datos en cualquier momento a través de la configuración del perfil.",
    faq4Answer:
      "Para obtener los mejores resultados, intenta formular las preguntas de manera clara y específica. Usa descripciones detalladas y proporciona contexto cuando sea necesario.",

    // Chat Suggestions
    helpWithCode: "Ayuda con código",
    helpWithCodeDesc: "Escribe el código que necesita ser corregido o mejorado",
    translateText: "Traducir texto",
    translateTextDesc: "Traduce texto a otro idioma",
    createPlan: "Crear un plan",
    createPlanDesc: "Desarrolla un plan de acción para tu proyecto",
    explainConcept: "Explicar un concepto",
    explainConceptDesc: "Obtén una explicación detallada de un concepto complejo",
    copy: "Copiar",
    copied: "¡Copiado!",

    // Chat Menu Actions
    share: "Compartir",
    rename: "Renombrar",
    archiveAction: "Archivar",
    chatLink: "Enlace del chat",
    links: "Enlaces:",
    allDetails: "Todos los detalles",
    stanceYes: "Sí",
    stanceLikely: "Probable",
    stanceInconclusive: "No concluyente",
    stanceNo: "No",

    // Medical Suggestions
    suggestionHealthAnswers: "Respuestas científicas sobre salud",
    suggestionHealthAnswersDesc: "Busco justificación científica para tus preguntas sobre salud y estilo de vida adecuado",

    // Hint Templates
    hintQuestion1: "Analiza el principio activo...",
    hintQuestion2: "Métodos de tratamiento para...",
    hintQuestion3: "Dieta para...",
    hintQuestion4: "Eficacia del procedimiento cosmético...",
    hintQuestion5: "Qué tomar para...",
    hintQuestion6: "Beneficios de productos...",
    hintQuestion7: "Vitaminas para...",
    hintQuestion8: "Cómo tomar... afecta la mejora de la salud",

    archive: "Archivo",
    noArchivedChats: "No hay chats archivados.",
    chooseChatToSeeMessages: "Elige un chat para ver los mensajes",
    archivedChatNotice: "Este chat fue archivado",
    endpointNotFound: "Endpoint no encontrado. Verifica que el servidor backend esté funcionando.",
    emailVerifiedSuccess: "Correo verificado exitosamente. Ahora puedes iniciar sesión.",

    // Shared Chat Screen
    sharedNotFound: "Chat no encontrado",
    sharedNotFoundDesc: "Este enlace puede haber caducado o sido eliminado.",
    serverError: "Error del servidor",
    serverErrorDesc: "Algo salió mal. Por favor, inténtalo más tarde.",
    networkError: "Error de conexión",
    networkErrorDesc: "Por favor, verifica tu conexión a internet e inténtalo de nuevo.",
    goToHome: "Ir a inicio",
    tryNachMed: "Probar NachMed AI",
    wantMoreAnswers: "¿Quieres más consejos médicos?",
    signUpForFree: "Regístrate gratis y obtén respuestas personalizadas sobre salud",
    createFreeAccount: "Crear cuenta gratuita",
    orDownloadApp: "o descarga la app",
    downloadAppDescription: "Descarga la app móvil, regístrate y obtén respuestas personalizadas sobre salud",
  },
  pt: {
    // Auth Screens
    login: "Entrar",
    register: "Registrar",
    forgotPassword: "Esqueceu a senha?",
    forgotPasswordDesc:
      "Digite seu e-mail e enviaremos um link para redefinir sua senha",
    backToLogin: "Voltar",
    sending: "Enviando...",
    email: "E-mail",
    password: "Senha",
    confirmPassword: "Confirmar senha",
    name: "Nome",
    createAccount: "Criar conta",
    alreadyHaveAccount: "Já tem uma conta?",
    dontHaveAccount: "Não tem conta?",
    loginFailed: "Erro ao entrar",
    registrationFailed: "Erro no registro",
    fillAllFields: "Por favor, preencha todos os campos",
    passwordsDontMatch: "As senhas não coincidem",
    acceptTerms: "Aceito os",
    termsLink: "Termos de uso",
    termsError: "Você deve aceitar os termos de uso",
    nameRequired: "Por favor, digite seu nome",
    nameMinLength: "O nome deve ter pelo menos 2 caracteres",
    emailRequired: "Por favor, digite seu e-mail",
    emailInvalid: "E-mail inválido",
    passwordRequired: "Por favor, digite sua senha",
    passwordMinLength: "A senha deve ter pelo menos 8 caracteres e conter uma letra e um número",
    confirmPasswordRequired: "Por favor, confirme sua senha",
    markdownSupport: "Suporte a Markdown",
    markdownSupportDesc: "Use Markdown para formatar suas mensagens",
    typingAnimation: "Animação de digitação suave",
    typingAnimationDesc: "As mensagens aparecem caractere por caractere",
    passwordTooShort: "A senha deve ter pelo menos 8 caracteres",
    currentPasswordIncorrect: "A senha atual está incorreta",
    passwordChangedSuccessfully: "Senha alterada com sucesso",
    alreadyExist: "Já existe uma conta com este e-mail",
    badGateway: "Algo deu errado. Por favor, tente novamente mais tarde",
    invalidLoginData: "E-mail ou senha incorretos",
    emailNotVerified: "E-mail não verificado. Por favor, verifique seu e-mail.",
    accountDeleted: "Esta conta foi excluída. O login não é mais possível.",
    continueWithGoogle: "Continuar com Google",
    sessionExpired: "Sessão encerrada",
    sessionExpiredDesc: "Por favor, faça login novamente",

    // Email Verification
    emailVerification: "Verificação de e-mail",
    verificationEmailSent: "Enviamos um código de verificação para",
    verificationCode: "Código de verificação",
    verificationCodeRequired: "O código de verificação é obrigatório",
    verificationCodeLength: "O código deve conter 6 dígitos",
    verifyEmail: "Verificar e-mail",
    verificationFailed: "Erro na verificação do código",
    resendCode: "Reenviar código",
    resendCodeIn: "Reenviar código em",
    codeResent: "Código reenviado para seu e-mail",
    resendFailed: "Erro ao reenviar o código",
    backToRegister: "Voltar ao registro",

    // Forgot Password
    sendResetCode: "Enviar código",
    resetPassword: "Redefinir senha",
    resetPasswordDesc: "Digite o código do e-mail e a nova senha para",
    newPassword: "Nova senha",
    forgotPasswordFailed: "Erro ao enviar o código",
    resetPasswordFailed: "Erro ao redefinir a senha",
    passwordResetSuccess: "Senha redefinida com sucesso",
    backToForgotPassword: "Voltar para senha esquecida",

    // Navigation & Layout
    chat: "Chat",
    profile: "Perfil",
    settings: "Configurações",
    blog: "Blog",
    newChat: "Novo chat",
    sharedChat: "Chat compartilhado",
    logout: "Sair",
    welcome: "Bem-vindo",
    loading: "Carregando...",
    opening_chat: "Abrindo chat...",

    // Chat Screen
    typeMessage: "Digite uma mensagem...",
    send: "Enviar",
    chatHistory: "Histórico do chat",
    hello: "Olá! Como você está?",
    howCanIHelp: "Como posso ajudar?",
    howCanIHelpSubtitle: "Seu assistente de IA para conversas sobre saúde física, nutrição adequada e estilo de vida saudável",
    writeMessage: "Escreva sua mensagem...",
    editTitle: "Editar título",
    deleteChat: "Excluir chat",
    deleteAll: "Excluir",
    confirmDeleteChat: "Tem certeza de que deseja excluir o chat?",
    medicalDisclaimer:
      "A resposta neste chat não é uma consulta médica profissional. Se precisar de ajuda médica profissional, consulte um profissional de saúde qualificado.",
    confirmArchiveChatTitle: "Arquivar chat?",
    confirmArchiveChatDesc:
      "Após arquivar, o chat desaparecerá da lista de chats ativos, mas permanecerá no arquivo.",
    archiveReadOnlyNotice:
      "Este chat está arquivado e está disponível apenas para leitura.",
    unarchiveChat: "Desarquivar chat",
    unarchiveConfirmation: "Desarquivar este chat?",
    unarchiveConfirmationDesc:
      "Após desarquivar, o chat aparecerá novamente na lista de chats ativos.",
    archivedChats: "Chats arquivados",
    showArchivedChats: "Mostrar chats arquivados",
    hideArchivedChats: "Ocultar chats arquivados",
    moreActions: "Mais ações",
    rateUp: "Avaliar positivamente",
    rateDown: "Avaliar negativamente",
    rateThankYouPositive: "Obrigado pela sua avaliação positiva!",
    rateThankYouNegative: "Obrigado pelo seu feedback!",

    // Profile Screen
    statistics: "Estatísticas",
    userId: "ID do usuário",
    accountStatus: "Status da conta",
    active: "Ativo",
    editProfile: "Editar perfil",
    editProfileButton: "Editar perfil",
    changePassword: "Alterar senha",
    changePasswordButton: "Alterar senha",
    resetPasswordButton: "Redefinir senha",
    sendResetEmail: "Enviar e-mail",
    resetPasswordEmailSent: "E-mail de redefinição enviado para seu endereço de e-mail",
    enterEmail: "Digite seu e-mail",
    phone: "Telefone",
    currentPassword: "Senha atual",
    confirmNewPassword: "Confirmar senha",
    save: "Salvar",
    cancel: "Cancelar",
    deleteAccount: "Excluir conta",
    joinedOn: "Entrou em",
    logoutConfirmation: "Confirmação de saída",
    logoutConfirmationDesc: "Tem certeza de que deseja sair?",
    deleteAccountConfirmation: "Confirmação de exclusão de conta",
    deleteAccountConfirmationDesc:
      "Tem certeza de que deseja excluir sua conta? Esta ação é irreversível.",
    enterCurrentPassword: "Digite a senha atual",
    delete: "Excluir",

    // Subscription
    subscription: "Assinatura",
    subscriptionStatus: "Status",
    subscriptionEnds: "Data de término",
    requestsLeft: "Solicitações restantes",
    needSubscription: "Assinatura necessária",
    buySubscription: "Comprar assinatura",
    inactive: "Inativa",
    subUnlimitedTitle: "Planos disponíveis",
    subNeedSubscriptionInfo: "Para continuar usando o bot, é necessária uma assinatura.",
    subBuyFor: "Comprar por {{amount}}",
    subThenPrice: "Depois {{amount}}/mês",
    subChooseOne: "Escolha uma das opções de assinatura",
    cancelSubscription: "Cancelar assinatura",
    cancelSubscriptionTitle: "Cancelar assinatura",
    cancelSubscriptionDesc: "Por favor, especifique o motivo do cancelamento:",
    loadingCancelOptions: "Carregando opções...",
    cancelOptionsUnavailable: "Opções de cancelamento não disponíveis",
    selectAtLeastOneReason: "Por favor, selecione pelo menos um motivo",
    enterOtherReason: "Por favor, especifique o motivo no campo 'Outro'",
    subscriptionCancelledSuccess: "Assinatura cancelada com sucesso",
    cancelSubscriptionError: "Erro ao cancelar a assinatura",
    failedToLoadCancelOptions: "Não foi possível carregar as opções de cancelamento",
    errorLoadingOptions: "Erro ao carregar opções",
    other: "Outro",
    specifyReason: "Especifique o motivo",
    subscriptionCancellationInfoTitle: "Assinatura cancelada",
    subscriptionCancellationInfoMessage:
      "Se você ainda tiver perguntas disponíveis ou seu período de assinatura ainda estiver ativo, você pode continuar usando o serviço até o final do período pago.",
    gotIt: "Entendido",

    // Modals (welcome / paywall / payment)
    welcomeTitle: "Olá!",
    welcomeSubtitleText:
      "Meu nome é AI Nachmed - sou um bot que facilitará e simplificará seu trabalho com o conhecido banco de dados médicos PubMed.",
    welcomeParagraphText:
      "Meus serviços são pagos, mas você pode fazer as 3 primeiras perguntas gratuitamente!",
    welcomePaymentParagraphText:
      "Após usar as perguntas gratuitas, para continuar usando o bot, você precisa comprar uma assinatura. Você pode pagar a assinatura com cartão bancário.",
    subscriptionNeededTitle: "Assinatura necessária!",
    subscriptionNeededText:
      "Você esgotou suas perguntas gratuitas. Para continuar, compre uma assinatura mensal por $10.",
    paymentConfirmTitle: "Confirmação de pagamento",
    paymentConfirmText:
      "Você está comprando uma assinatura mensal de $10 através do WayForPay. Você pode cancelar a qualquer momento.",
    pay: "Pagar",
    subscriptionLimitText:
      "Infelizmente, você esgotou seu limite de perguntas. Para continuar recebendo respostas do nosso bot, você precisa comprar uma assinatura mensal paga de $10",
    subscriptionExpiredTitle: "Assinatura expirada",
    subscriptionExpiredText:
      "Sua assinatura expirou. Para continuar usando nossos serviços, renove sua assinatura.",
    paymentRequired: "Pagamento necessário",
    paymentRequiredText:
      "É necessária uma assinatura para criar um novo chat. Por favor, compre uma assinatura para continuar.",

    // Settings Screen
    basicSettings: "Configurações básicas",
    chatSettings: "Configurações do chat",
    backup: "Backup",
    dangerZone: "Zona de perigo",
    darkTheme: "Tema escuro",
    darkThemeDesc: "Alternar entre tema claro e escuro",
    language: "Idioma",
    languageDesc: "Escolha o idioma da interface",
    animations: "Animações",
    animationsDesc: "Ativar animações da interface",
    showTimestamps: "Mostrar horários",
    showTimestampsDesc: "Mostrar a hora de envio de cada mensagem",
    compactMode: "Modo compacto",
    compactModeDesc: "Reduzir o espaçamento entre mensagens",
    autoSave: "Salvamento automático",
    autoSaveDesc: "Salvar chats automaticamente",
    exportData: "Exportar dados",
    exportDataDesc: "Baixar todos os dados em formato JSON",
    importData: "Importar dados",
    importDataDesc: "Restaurar dados do backup",
    deleteAllData: "Excluir todos os dados",
    deleteAllDataDesc: "Excluir permanentemente todos os chats e configurações",
    export: "Exportar",
    import: "Importar",
    download: "Baixar",
    exportDataModalDesc:
      "Será criado um arquivo com todos os seus chats, configurações e dados de perfil.",
    importDataModalDesc: "Cole o conteúdo do arquivo JSON de backup:",
    pasteJsonData: "Cole os dados JSON aqui...",
    deleteConfirmation: "Confirmação de exclusão",
    deleteConfirmationDesc:
      "Tem certeza de que deseja excluir todos os dados? Esta ação não pode ser desfeita!",
    exportError: "Erro ao exportar dados",
    importSuccess:
      "Dados importados com sucesso! Recarregue a página para aplicar as alterações.",
    importError: "Erro ao importar dados. Por favor, verifique o formato do arquivo.",
    dataDeleted: "Todos os dados foram excluídos. A página será recarregada.",

    // Search Component
    searchChats: "Pesquisar chats...",
    clearSearch: "Limpar pesquisa",
    searchResults: "Resultados da pesquisa",
    noSearchResults: "Nenhum resultado encontrado",
    tryDifferentKeywords: "Tente outras palavras-chave",
    match: "correspondência",
    matches: "correspondências",
    moreMatches: "mais correspondências",
    you: "Você",
    searchingFor: "Pesquisando por",
    foundInMessages: "Encontrado em mensagens",
    foundInTitle: "Encontrado no título",
    searchTip: "Pesquisar em nomes de chats e mensagens",
    searchEmptyState: "Comece a digitar para pesquisar em seus chats",
    totalResults: "{{count}} resultado encontrado",
    totalResults_plural: "{{count}} resultados encontrados",
    recentChats: "Chats recentes",
    navigate: "Navegar",
    select: "Selecionar",
    close: "Fechar",
    justNow: "Agora mesmo",
    hoursAgo: "há {{hours}} horas",
    yesterday: "Ontem",

    // Info Blocks Component
    information: "Informação",
    askQuestion: "Nova pergunta",
    advantages: "Vantagens",
    advantage1: "Respostas rápidas e precisas",
    advantage2: "Suporte em português",
    advantage3: "As 3 primeiras perguntas são gratuitas",
    advantage4: "Disponível 24/7",
    privacy: "Privacidade",
    privacy1: "Seus dados estão protegidos",
    privacy2: "Não compartilhamos informações com terceiros",
    privacy3: "Você pode excluir o histórico a qualquer momento",
    privacy4: "Cumprimos o GDPR",

    // FAQ Screen
    faq: "FAQ",
    faqScreen: "FAQ",
    faqSubtitle: "Encontre respostas para as perguntas mais frequentes sobre nosso serviço",
    faqSearchPlaceholder: "Pesquisar nas perguntas...",
    faqCategory: "Categoria",
    faqAllCategories: "Todas as categorias",
    faqGeneral: "Perguntas gerais",
    faqTechnical: "Perguntas técnicas",
    faqPrivacy: "Privacidade",
    faqUsage: "Uso",
    faqStillHaveQuestions: "Ainda tem perguntas?",
    faqContactUs: "Entre em contato",
    faqBackToTop: "Voltar ao topo",
    faq1: "É seguro usar IA?",
    faq2: "Quanto custa?",
    faq3: "Meus dados são armazenados?",
    faq4: "Como melhorar a qualidade das respostas?",
    faq1Answer:
      "Sim, nossa IA é segura de usar. Utilizamos métodos de proteção de dados de última geração e cumprimos todos os padrões de segurança. Seus dados estão protegidos e não são compartilhados com terceiros.",
    faq2Answer:
      "Meus serviços são pagos, mas você pode fazer as 3 primeiras perguntas gratuitamente! Após usar as perguntas gratuitas, para continuar usando o bot, você precisa comprar uma assinatura. Você pode pagar a assinatura com cartão bancário.",
    faq3Answer:
      "Sim, armazenamos o histórico dos seus chats para melhorar a qualidade das respostas. Você pode excluir seus dados a qualquer momento através das configurações do perfil.",
    faq4Answer:
      "Para obter os melhores resultados, tente formular as perguntas de forma clara e específica. Use descrições detalhadas e forneça contexto quando necessário.",

    // Chat Suggestions
    helpWithCode: "Ajuda com código",
    helpWithCodeDesc: "Escreva o código que precisa ser corrigido ou melhorado",
    translateText: "Traduzir texto",
    translateTextDesc: "Traduza texto para outro idioma",
    createPlan: "Criar um plano",
    createPlanDesc: "Desenvolva um plano de ação para seu projeto",
    explainConcept: "Explicar um conceito",
    explainConceptDesc: "Obtenha uma explicação detalhada de um conceito complexo",
    copy: "Copiar",
    copied: "Copiado!",

    // Chat Menu Actions
    share: "Compartilhar",
    rename: "Renomear",
    archiveAction: "Arquivar",
    chatLink: "Link do chat",
    links: "Links:",
    allDetails: "Todos os detalhes",
    stanceYes: "Sim",
    stanceLikely: "Provável",
    stanceInconclusive: "Inconclusivo",
    stanceNo: "Não",

    // Medical Suggestions
    suggestionHealthAnswers: "Respostas científicas sobre saúde",
    suggestionHealthAnswersDesc: "Busco justificativa científica para suas perguntas sobre saúde e estilo de vida adequado",

    // Hint Templates
    hintQuestion1: "Analise o princípio ativo...",
    hintQuestion2: "Métodos de tratamento para...",
    hintQuestion3: "Dieta para...",
    hintQuestion4: "Eficácia do procedimento cosmético...",
    hintQuestion5: "O que tomar para...",
    hintQuestion6: "Benefícios dos produtos...",
    hintQuestion7: "Vitaminas para...",
    hintQuestion8: "Como tomar... afeta a melhoria da saúde",

    archive: "Arquivo",
    noArchivedChats: "Não há chats arquivados.",
    chooseChatToSeeMessages: "Escolha um chat para ver as mensagens",
    archivedChatNotice: "Este chat foi arquivado",
    endpointNotFound: "Endpoint não encontrado. Verifique se o servidor backend está funcionando.",
    emailVerifiedSuccess: "E-mail verificado com sucesso. Agora você pode entrar.",

    // Shared Chat Screen
    sharedNotFound: "Chat não encontrado",
    sharedNotFoundDesc: "Este link pode ter expirado ou sido removido.",
    serverError: "Erro do servidor",
    serverErrorDesc: "Algo deu errado. Por favor, tente novamente mais tarde.",
    networkError: "Erro de conexão",
    networkErrorDesc: "Por favor, verifique sua conexão com a internet e tente novamente.",
    goToHome: "Ir para início",
    tryNachMed: "Experimente o NachMed AI",
    wantMoreAnswers: "Quer mais conselhos médicos?",
    signUpForFree: "Cadastre-se gratuitamente e receba respostas personalizadas sobre saúde",
    createFreeAccount: "Criar conta gratuita",
    orDownloadApp: "ou baixe o aplicativo",
    downloadAppDescription: "Baixe o aplicativo móvel, cadastre-se e receba respostas personalizadas sobre saúde",
  },
};
